import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { GeneralService } from 'src/app/services/general.service';
import { InscripcionConvenioService } from 'src/app/services/inscripcion-convenio.service';
import { UsuarioService } from 'src/app/services/usuario.service';
import { URL_DOCS } from 'src/app/config/config';
import Swal from 'sweetalert2';

import { Subscription } from 'rxjs';
import { MercadoPagoSocketService } from 'src/app/services/payment-socket.service';
type ViewMode = 'list' | 'detail' | 'edit';
type DetailTab = 'detail' | 'beneficiaries' | 'configuration' | 'paymentHistory';
type PaymentMethodModalStep = 'options' | 'mercadoPago' | 'form';
@Component({
    selector: 'app-plans',
    templateUrl: './plans.component.html',
    styleUrls: ['./plans.component.css']
})
export class PlansComponent implements OnInit, OnDestroy {
    @Input()
    usuario: any = {};

    // =========================================================
    // Estado del plan
    // =========================================================

    private paymentStatusSubscription: Subscription | null = null;
    // =========================================================
    // PLANES
    // =========================================================
    public planes: any[] = [];
    public plan_selected: any = {};
    public currentView: ViewMode = 'list';
    public activeDetailTab: DetailTab = 'detail';
    public loadingPlans = false;
    public showAllSpecialties = false;
    /**
     * Cantidad de especialidades visibles antes de mostrar
     * el botón "Ver más".
     */
    private readonly specialtiesPreviewLimit = 5;
    // =========================================================
    // BENEFICIARIOS
    // =========================================================
    public beneficiariesWorking: any[] = [];
    public showBeneficiaryForm = false;
    public showBeneficiaryModal = false;
    public editingBeneficiaryIndex: number | null = null;
    public beneficiaryForm!: FormGroup;
    public beneficiaryFlagDropdownOpen = false;
    public savingBeneficiary = false;
    public modifyingConvenio = false;
    public addingNewSlotInModify = false;
    public editingExistingEmptySlot = false;
    // =========================================================
    // MODIFICACIÓN DE PLAN
    // =========================================================
    private pendingModifyPlanSubsPayload: any = null;
    private pendingModifyPlanOriginalPlan: any = null;
    // =========================================================
    // ELIMINACIÓN BENEFICIARIO / CUPO
    // =========================================================
    public showDeleteBeneficiaryConfirmModal = false;
    public beneficiaryDeleteSelected: any = null;
    public beneficiaryDeleteIndex: number | null = null;
    public beneficiaryDeleteIsSlotOnly = false;
    public beneficiaryDeleteActionRequest: 'DEL_SLOT' | 'DEL_SLOT_BEN' | 'DEL_BEN' = 'DEL_BEN';
    // =========================================================
    // CANCELAR SOLICITUD FUTURA
    // =========================================================
    public showCancelFutureRequestConfirmModal = false;
    public futureRequestCancelSelected: any = null;
    public cancellingFutureRequest = false;
    // =========================================================
    // CANCELACIÓN SUSCRIPCIÓN
    // =========================================================
    public showCancelSubscriptionConfirmModal = false;
    public cancellingSubscription = false;
    // =========================================================
    // MODALES COMPARACIÓN PLAN
    // =========================================================
    public showPlanChangeComparisonModal = false;
    public showPlanChangeFinalConfirmModal = false;
    public planChangeComparisonMode: 'CHANGE' | 'FINAL' = 'CHANGE';
    // =========================================================
    // SNAPSHOTS
    // =========================================================
    private originalBeneficiariesModifySnapshot: any[] = [];
    private beneficiariesBeforeLastChange: any[] = [];
    public originalBeneficiarySlotCount = 0;
    public modifiedBeneficiarySlotCount = 0;
    private beneficiarySlotCountBeforeLastChange = 0;
    // =========================================================
    // DOCUMENTOS / BOLETAS
    // =========================================================
    public URL_DOCS = URL_DOCS;
    public downloadingReceiptIds = new Set<string>();
    // =========================================================
    // HISTORIAL DE PAGOS
    // =========================================================
    // false = oculta el TAB / true = muestra el TAB.
    // Para volver a habilitarlo solo cambia este valor a true.
    public showPaymentHistoryTab = true;
    public paymentHistoryRows: any[] = [];
    public paymentToRegularize: any = null;
    public showRegularizePaymentModal = false;
    public generatingRegularizePayment = false;
    public regularizationWaitingPayment = false;
    public regularizationPending = false;
    public regularizationSuccess = false;
    public regularizationError = '';
    // =========================================================
    // MODIFICAR MEDIO DE PAGO - MERCADO PAGO
    // =========================================================
    public showPaymentMethodModal = false;
    public paymentMethodModalStep: PaymentMethodModalStep = 'options';
    public initializingPaymentMethod = false;
    public tokenizingPaymentMethod = false;
    public paymentMethodError = '';
    public generatedCardTokenId = '';
    private mercadoPagoInstance: any = null;
    private mercadoPagoCardNumberField: any = null;
    private mercadoPagoExpirationDateField: any = null;
    private mercadoPagoSecurityCodeField: any = null;
    private mercadoPagoSdkPromise: Promise<void> | null = null;
    /**
     * En el historial se muestra únicamente la siguiente cuota simulada.
     */
    private readonly MAX_PROJECTED_PAYMENTS = 1;
    // =========================================================
    // TELÉFONOS
    // =========================================================
    public areaCodes: any[] = [
        {
            cou_phone_code: '56',
            cou_flag: 'fi-cl',
            cou_min_phone: 9,
            cou_max_phone: 9
        }
    ];
    public selectedBeneficiaryAreaCode: any = {
        cou_phone_code: '56',
        cou_flag: 'fi-cl',
        cou_min_phone: 9,
        cou_max_phone: 9
    };
    public todayDate = this.getTodayIsoDate();
    // =========================================================
    // TÉRMINOS Y CONDICIONES
    // =========================================================
    public showTermsAndConditionsModal = false;
    public termsAndConditions: Array<{
        title: string;
        paragraphs: string[];
        bullets?: string[];
    }> = [
        {
            title: 'Términos y Condiciones de Contratación del Servicio AlmaMedis',
            paragraphs: [
                'AlmaMedis — Servicio de Telemedicina',
                'Al seleccionar la opción “Acepto los términos y condiciones”, el usuario declara haber leído, comprendido y aceptado en su totalidad las condiciones de contratación y uso del servicio de telemedicina AlmaMedis (en adelante, “AlmaMedis” o “el Servicio”), contenidas en el presente documento.'
            ]
        },
        {
            title: '1. Objeto',
            paragraphs: [
                'El presente documento regula la contratación, uso y condiciones comerciales aplicables al servicio de telemedicina prestado por AlmaMedis a través de sus plataformas y canales habilitados, así como los derechos y obligaciones del titular y de sus beneficiarios.'
            ]
        },
        {
            title: '2. Contratación del Plan',
            paragraphs: [
                'La contratación se realizará conforme al plan seleccionado por el usuario, incluyendo su valor, prestaciones, especialidades disponibles, topes de atención, vigencia y demás condiciones comerciales informadas antes de confirmar la suscripción.',
                'El usuario podrá revisar el detalle del plan antes de autorizar el pago.',
                'Los planes ofrecidos por AlmaMedis tienen una vigencia anual, sin perjuicio de que su cobro se realiza mediante cuotas mensuales, conforme se detalla en la cláusula 4 siguiente.'
            ]
        },
        {
            title: '3. Titular y Beneficiarios',
            paragraphs: [
                'El servicio podrá ser utilizado por el titular y por los beneficiarios registrados, de acuerdo con las condiciones y límites establecidos en el plan contratado.',
                'El usuario declara que la información proporcionada es verdadera, completa y actualizada, y que cuenta con autorización para registrar a los beneficiarios incorporados al plan.'
            ]
        },
        {
            title: '4. Vigencia, Pago y Renovación Automática',
            paragraphs: [
                'El plan contratado tiene una vigencia anual. No obstante lo anterior, el valor total del plan se cobrará en cuotas mensuales, mediante el medio de pago registrado por el usuario, durante toda la vigencia del plan.',
                'El usuario autoriza expresamente a AlmaMedis y al proveedor de pagos correspondiente a procesar el cobro mensual del plan mediante el medio de pago registrado, de forma recurrente y automática.',
                'Al término de cada periodo anual de vigencia, la suscripción se renovará automáticamente por un nuevo periodo de igual duración, y se continuará cobrando mensualmente, salvo que el usuario solicite su cancelación conforme al procedimiento establecido en la cláusula 10 siguiente, con anterioridad a la fecha de renovación.'
            ]
        },
        {
            title: '5. Ajuste de Precios',
            paragraphs: [
                'El valor de las cuotas mensuales podrá ser ajustado por AlmaMedis conforme a la variación del Índice de Precios al Consumidor (IPC) u otro indicador que lo reemplace, dicho ajuste podrá aplicarse, especialmente, en los procesos de renovación automática del plan señalados en la cláusula 4.',
                'Todo ajuste de precio será informado al titular del plan con la anticipación mínima señalada en la cláusula 11 (Modificaciones del Plan), de manera que este pueda evaluar la continuidad o cancelación de su suscripción antes de que el nuevo valor entre en vigencia.'
            ]
        },
        {
            title: '6. Incumplimiento de Pago y Suspensión del Servicio',
            paragraphs: [
                'En caso de rechazo, vencimiento, mora o cualquier imposibilidad de procesar el cobro mensual, AlmaMedis podrá suspender temporalmente el acceso a los beneficios del plan respecto del titular y de sus beneficiarios, hasta que la situación de pago sea regularizada.',
                'Si el no pago persiste o se repite conforme a los plazos y condiciones que AlmaMedis informe a través de sus canales habilitados, AlmaMedis podrá proceder a la suspensión definitiva del servicio y a la terminación de la suscripción, sin perjuicio de las obligaciones de pago ya devengadas por el usuario.'
            ]
        },
        {
            title: '7. Cobertura y Topes del Plan',
            paragraphs: [
                'Las atenciones estarán sujetas a las especialidades, cantidades, topes anuales y demás coberturas indicadas en el detalle del plan.',
                'Los topes podrán ser individuales o compartidos entre el titular y sus beneficiarios, según la configuración del plan contratado.',
                'Las prestaciones no utilizadas durante el periodo correspondiente no serán acumulables, salvo que las condiciones particulares del plan indiquen expresamente lo contrario.'
            ]
        },
        {
            title: '8. Prestaciones de Telemedicina',
            paragraphs: [
                'Las atenciones serán realizadas a distancia mediante las plataformas y canales habilitados por AlmaMedis.',
                'La telemedicina no reemplaza una atención presencial cuando el profesional determine que esta es necesaria. Tampoco corresponde utilizar el servicio ante una urgencia o emergencia médica. En dichos casos, el paciente deberá acudir inmediatamente a un servicio de urgencia o comunicarse con los servicios de emergencia correspondientes.',
                'La contratación del plan no garantiza un diagnóstico, tratamiento o resultado médico específico. Las decisiones clínicas serán adoptadas exclusivamente por el profesional de salud, de acuerdo con los antecedentes disponibles y su criterio profesional.',
                'El usuario y sus beneficiarios comprenden y aceptan que las consultas correspondientes a una determinada especialidad podrán ser realizadas por médicos especialistas en dicha área o por médicos debidamente capacitados y facultados para efectuar atenciones propias de esa especialidad, sin que ello implique necesariamente que el profesional tratante ostente el título de especialista.',
                'Antes de cada atención podrán solicitarse las autorizaciones y consentimientos requeridos para realizar la prestación de salud a distancia.'
            ]
        },
        {
            title: '9. Disponibilidad del Servicio',
            paragraphs: [
                'La disponibilidad de profesionales, horarios y especialidades podrá variar según la oferta vigente, la ubicación del paciente, las condiciones del plan y la capacidad operativa de la plataforma.',
                'AlmaMedis realizará esfuerzos razonables para mantener la continuidad del servicio, sin perjuicio de interrupciones ocasionadas por mantenimiento, fallas de conectividad, problemas tecnológicos o situaciones de fuerza mayor.'
            ]
        },
        {
            title: '10. Cancelación de la Suscripción',
            paragraphs: [
                'El usuario podrá solicitar la cancelación de la suscripción a través de los canales habilitados por AlmaMedis.',
                'La cancelación impedirá la generación de nuevos cobros posteriores a su fecha efectiva. Las condiciones de uso del periodo ya pagado y la existencia de eventuales devoluciones se regirán por lo informado en el detalle del plan y por la normativa vigente.'
            ]
        },
        {
            title: '11. Restricciones de Recontratación',
            paragraphs: [
                'En caso de que el titular cancele o dé de baja su plan, no podrá contratar nuevamente el mismo plan sino hasta transcurrido un periodo mínimo de un (1) año, contado desde la fecha efectiva de cancelación.',
                'Asimismo, en caso de que un beneficiario sea eliminado del plan, dicho beneficiario no podrá ser reincorporado al mismo sino hasta el término de la vigencia del ciclo del plan al cual pertenecía al momento de su eliminación.'
            ]
        },
        {
            title: '12. Modificaciones del Plan',
            paragraphs: [
                'AlmaMedis podrá modificar las condiciones, coberturas o valores del servicio cuando existan razones comerciales, operativas o regulatorias que lo justifiquen.',
                'Las modificaciones relevantes, incluyendo los ajustes de precio señalados en la cláusula 5, serán informadas al usuario con al menos 30 días de anticipación y se aplicarán hacia el futuro, respetando los derechos establecidos por la legislación vigente.',
                'El usuario podrá eliminar beneficiarios de su plan, con la restricción de no poder incorporar nuevos beneficiarios hasta que finalice el ciclo de vigencia correspondiente.'
            ]
        },
        {
            title: '13. Datos Personales',
            paragraphs: [
                'El usuario autoriza el tratamiento de sus datos personales y de los datos de los beneficiarios para gestionar la suscripción, coordinar las atenciones, procesar los pagos, enviar comunicaciones relacionadas con el servicio y cumplir las obligaciones legales correspondientes.',
                'Los datos personales y de salud serán tratados conforme a la normativa vigente y a la Política de Privacidad de AlmaMedis.'
            ]
        },
        {
            title: '14. Aceptación',
            paragraphs: [
                'Al continuar con la contratación, el usuario declara que:'
            ],
            bullets: [
                'Es mayor de edad y tiene capacidad para contratar.',
                'Revisó el detalle, valor y condiciones del plan seleccionado, incluyendo su vigencia anual y su modalidad de cobro mensual.',
                'Autoriza el cobro recurrente y automático mediante el medio de pago registrado, incluyendo los ajustes de precio conforme a IPC informados según la cláusula 5.',
                'La información ingresada es correcta y corresponde al titular y sus beneficiarios.',
                'Conoce las limitaciones propias de una atención realizada mediante telemedicina, incluyendo que las consultas de especialidad podrán ser realizadas por médicos capacitados para dicho efecto y no necesariamente por un médico especialista en la materia.',
                'Conoce las consecuencias del no pago, incluyendo la eventual suspensión temporal o definitiva del servicio, así como las restricciones de recontratación señaladas en la cláusula 11.',
                'Acepta los presentes términos y condiciones y la Política de Privacidad de AlmaMedis.'
            ]
        }
    ];
    // =========================================================
    // CONSTRUCTOR
    // =========================================================
    constructor(
        public generalService: GeneralService,
        private fb: FormBuilder,
        private usuarioService: UsuarioService,
        public inscripcionConvenioService: InscripcionConvenioService,
        private paymentSocketService: MercadoPagoSocketService
    ) {}

    // =========================================================
    // INIT / DESTROY
    // =========================================================
    ngOnInit(): void {
        this.initBeneficiaryForm();
        this.getCodPaises();
        this.initPaymentSocket();
        this.postListPlansXBeneficiaries();
    }

    ngOnDestroy(): void {
        if (this.paymentStatusSubscription) {
            this.paymentStatusSubscription.unsubscribe();
            this.paymentStatusSubscription = null;
        }
    }

    // =========================================================
    // SOCKET DE PAGOS - REGULARIZACIÓN
    // =========================================================
    private initPaymentSocket(): void {
        this.paymentStatusSubscription = this.paymentSocketService.PaymentStatus().subscribe((data: any) => {
            if (data === null) return;
            console.log('[PlansComponent] PaymentStatus:', data);
            void this.handlePaymentStatus(data);
        });
    }

    private async handlePaymentStatus(data: any): Promise<void> {
        if (!this.regularizationWaitingPayment) return;
        if (!this.isCurrentRegularizationPaymentEvent(data)) {
            console.log('[REGULARIZACIÓN] Evento ignorado porque pertenece a otra operación/proveedor:', data);
            return;
        }

        const status = String(data?.status || '').trim().toLowerCase();
        const paymentStatus = String(data?.paymentStatus || data?.payment_status || '').trim().toLowerCase();
        console.log('[REGULARIZACIÓN] provider:', data?.providerPay, 'status:', status, 'paymentStatus:', paymentStatus);

        if (status === 'success' && paymentStatus === 'approved') {
            await this.handleRegularizationPaymentApproved(data);
            return;
        }
        if (status === 'failure') {
            this.handleRegularizationPaymentFailure(data);
            return;
        }
        if (status === 'pending') this.handleRegularizationPaymentPending(data);
    }

    private isCurrentRegularizationPaymentEvent(data: any): boolean {
        const expectedProvider = this.cleanString(this.paymentToRegularize?.providerPay).toUpperCase();
        const eventProvider = this.cleanString(data?.providerPay || data?.provider || data?.sub_pay_provider).toUpperCase();
        if (expectedProvider && eventProvider && expectedProvider !== eventProvider) return false;

        const expectedOrderId = this.cleanString(this.paymentToRegularize?.order_id || this.paymentToRegularize?.provider_reference);
        const eventOrderId = this.cleanString(data?.orderId || data?.order_id || data?.providerReference || data?.provider_reference);
        if (expectedOrderId && eventOrderId && expectedOrderId !== eventOrderId) return false;

        const expectedSubsId = Number(this.paymentToRegularize?.subsId || 0);
        const eventSubsId = Number(data?.subsId || data?.subs_id || 0);
        if (expectedSubsId > 0 && eventSubsId > 0 && expectedSubsId !== eventSubsId) return false;

        return true;
    }

    private async handleRegularizationPaymentApproved(data: any): Promise<void> {
        console.log('[REGULARIZACIÓN] Pago aprobado:', data);

        // Conservamos el loader mientras refrescamos el estado real desde backend.
        this.regularizationWaitingPayment = true;
        this.regularizationPending = false;
        this.regularizationSuccess = false;
        this.regularizationError = '';

        const amountPaid = Number(data?.amountPaid ?? data?.amount_paid ?? data?.amount ?? 0);
        if (Number.isFinite(amountPaid) && amountPaid > 0 && this.paymentToRegularize) {
            this.paymentToRegularize.amount = amountPaid;
        }

        try {
            await this.reloadPlanAfterRegularization();
            this.regularizationWaitingPayment = false;
            this.regularizationSuccess = true;
        } catch (error) {
            console.error('[REGULARIZACIÓN] Pago confirmado, pero ocurrió un error refrescando el plan:', error);

            // El pago ya está confirmado. No lo mostramos como rechazado por un
            // problema secundario de refresco de pantalla.
            this.regularizationWaitingPayment = false;
            this.regularizationSuccess = true;
            this.regularizationError = 'El pago fue confirmado, pero no pudimos actualizar el detalle del plan automáticamente. Al volver a abrir tus planes se cargará el estado actualizado.';
        }
    }

    private handleRegularizationPaymentFailure(data: any): void {
        console.error('[REGULARIZACIÓN] Pago rechazado/fallido:', data);

        this.regularizationWaitingPayment = false;
        this.regularizationPending = false;
        this.regularizationSuccess = false;
        this.regularizationError = data?.message
            || data?.paymentMessage
            || 'El pago no pudo ser procesado. Puedes intentarlo nuevamente.';
    }

    private handleRegularizationPaymentPending(data: any): void {
        console.log('[REGULARIZACIÓN] Pago pendiente:', data);

        this.regularizationWaitingPayment = true;
        this.regularizationPending = true;
        this.regularizationSuccess = false;
        this.regularizationError = '';
    }

    private async reloadPlanAfterRegularization(): Promise<void> {
        const originalPlan = { ...this.plan_selected };
        const subsId = Number(this.paymentToRegularize?.subsId || 0);
        const plans = await this.postListPlansXBeneficiaries();

        let updatedPlan = null;

        if (subsId > 0) {
            updatedPlan = (plans || []).find((plan: any) => {
                return Number(this.getPaymentPlan(plan)?.subs_id || 0) === subsId;
            }) || null;
        }

        if (!updatedPlan) {
            updatedPlan = this.findPlanAfterRefresh(plans, originalPlan);
        }

        if (!updatedPlan) {
            throw new Error(`No se encontró la suscripción ${subsId || ''} después de refrescar los planes.`);
        }

        this.plan_selected = updatedPlan;
        this.setBeneficiariesWorkingFromPlan();
        this.refreshPaymentHistory();
    }

    // =========================================================
    // HISTORIAL DE PAGOS
    // =========================================================
    private refreshPaymentHistory(): void {
        const realRows = this.buildPaymentHistory(this.plan_selected);
        const projectedRows = this.buildProjectedPaymentHistory(this.plan_selected, realRows);
        this.paymentHistoryRows = [
            ...realRows,
            ...projectedRows
        ];
    }
    /**
     * Construye el historial exclusivamente desde planPagos[].charges.
     * Cada nroCiclo de charges genera una fila en el historial.
     */
    private buildPaymentHistory(plan: any): any[] {
    if (!plan || !Array.isArray(plan?.planPagos) || plan.planPagos.length === 0) {
        return [];
    }

    const history: any[] = [];

    plan.planPagos.forEach((paymentPlan: any, paymentPlanIndex: number) => {
        const charges = Array.isArray(paymentPlan?.charges)
            ? paymentPlan.charges
            : [];

        charges.forEach((charge: any, chargeIndex: number) => {
            const rawCycle = charge?.nroCiclo;

            if (rawCycle === null || rawCycle === undefined || rawCycle === '') {
                return;
            }

            const cycle = Number(rawCycle);

            if (!Number.isFinite(cycle)) {
                return;
            }

            const rawDate = charge?.fechaPago || null;
            const amount = Number(charge?.montoPago || 0);
            const rawStatus = String(charge?.statusPago || '').trim().toUpperCase();
            const attemptNumber = Number(charge?.numberAttemp || 0);

            const isFreeDaysCycle = cycle === 0;

            const statusData = isFreeDaysCycle
                ? {
                    status: 'PAID',
                    statusLabel: 'Pagado / días gratis'
                }
                : this.getPaymentHistoryStatusData(rawStatus);

            const boleta =
                charge?.boleta === null || charge?.boleta === undefined
                    ? ''
                    : String(charge.boleta).trim();

            history.push({
                rowType: 'CHARGE',
                isProjected: false,
                subs_id: Number(paymentPlan?.subs_id || 0),
                sub_pay_id: Number(paymentPlan?.sub_pay_id || 0),
                cycle: cycle,
                rawDate: rawDate,
                date: this.formatDateToDisplay(rawDate),
                amount: amount,
                rawStatus: rawStatus,
                status: statusData.status,
                statusLabel: statusData.statusLabel,
                statusDetail: isFreeDaysCycle
                    ? 'Periodo correspondiente a días gratis'
                    : this.getPaymentStatusDetail(rawStatus, attemptNumber, cycle),
                attemptNumber: attemptNumber,
                boleta: boleta,
                receiptAvailable: !!boleta,
                receipt: boleta
                    ? {
                        sub_tic_path_file: boleta
                    }
                    : null,
                provider: paymentPlan?.sub_pay_provider || '',
                canRegularize: !isFreeDaysCycle && this.canRegularizePayment(
                    rawStatus,
                    attemptNumber,
                    paymentPlan?.sub_pay_provider
                ),
                nextPayment: false,
                downloadKey: `${paymentPlan?.subs_id || paymentPlanIndex}_${cycle}_${chargeIndex}`
            });
        });
    });

    return history.sort((first: any, second: any) => {
        const firstCycle = Number(first?.cycle ?? 0);
        const secondCycle = Number(second?.cycle ?? 0);

        if (firstCycle !== secondCycle) {
            return firstCycle - secondCycle;
        }

        const firstDate = this.parsePlanDate(first?.rawDate);
        const secondDate = this.parsePlanDate(second?.rawDate);

        return (firstDate ? firstDate.getTime() : 0)
            - (secondDate ? secondDate.getTime() : 0);
    });
}

    /**
     * Mantengo el nombre buildPaidPaymentHistory para no alterar
     * otras llamadas existentes, pero ahora construye TODAS las
     * facturaciones reales, no solamente las aprobadas.
     */
    private buildPaidPaymentHistory(plan: any): any[] {
        const history: any[] = [];
        const processedReceipts = new Set<string>();
        const processedCycles = new Set<number>();
        const paymentPlans = Array.isArray(plan?.planPagos)
            ? plan.planPagos
            : [];
        paymentPlans.forEach((paymentPlan: any, paymentIndex: number) => {
            const receipts = Array.isArray(paymentPlan?.listBoletas)
                ? paymentPlan.listBoletas
                : [];
            // =====================================================
            // HISTORIAL QUE VIENE EN listBoletas
            // =====================================================
            receipts.forEach((receipt: any, receiptIndex: number) => {
                const receiptKey = receipt?.sub_tic_id
                    ? `ID_${receipt.sub_tic_id}`
                    : receipt?.sub_tic_token
                        ? `TOKEN_${receipt.sub_tic_token}`
                        : receipt?.sub_tic_path_file
                            ? `PATH_${receipt.sub_tic_path_file}`
                            : `ROW_${paymentIndex}_${receiptIndex}`;
                if (processedReceipts.has(receiptKey))
                    return;
                processedReceipts.add(receiptKey);
                const rawCycle = receipt?.subs_his_number_cicle
                    ?? paymentPlan?.subs_his_number_cicle
                    ?? null;
                const cycle = rawCycle === null || rawCycle === undefined || rawCycle === ''
                    ? null
                    : Number(rawCycle);
                if (cycle !== null && Number.isFinite(cycle))
                    processedCycles.add(cycle);
                const rawDate = receipt?.subs_his_date_payment
                    || paymentPlan?.subs_his_date_payment
                    || null;
                const amount = Number(receipt?.subs_his_monto_pay
                    ?? paymentPlan?.sub_pay_total_amount
                    ?? 0);
                /*
                 * Las boletas históricas antiguas pueden no traer status.
                 * Si existe una boleta física y no hay estado, se considera
                 * APPROVED por compatibilidad con los registros anteriores.
                 */
                const rawStatus = String(receipt?.subs_his_payment_status
                    || (receipt?.sub_tic_path_file ? 'APPROVED' : '')
                    || '').trim().toUpperCase();
                const statusData = this.getPaymentHistoryStatusData(rawStatus);
                const attemptNumber = Number(receipt?.subs_his_attempt_number || 0);
                history.push({
                    rowType: 'REAL',
                    isProjected: false,
                    sub_tic_id: Number(receipt?.sub_tic_id || 0),
                    subs_id: Number(paymentPlan?.subs_id || 0),
                    sub_pay_id: Number(paymentPlan?.sub_pay_id || 0),
                    cycle,
                    rawDate,
                    date: this.formatDateToDisplay(rawDate),
                    amount,
                    rawStatus,
                    status: statusData.status,
                    statusLabel: statusData.statusLabel,
                    statusDetail: this.getPaymentStatusDetail(rawStatus, attemptNumber, cycle),
                    attemptNumber,
                    receiptAvailable: rawStatus === 'APPROVED'
                        && !!String(receipt?.sub_tic_path_file || '').trim(),
                    receipt,
                    provider: receipt?.sub_tic_provider || paymentPlan?.sub_pay_provider || '',
                    canRegularize: this.canRegularizePayment(rawStatus, attemptNumber, receipt?.sub_tic_provider || paymentPlan?.sub_pay_provider),
                    nextPayment: false
                });
            });
            // =====================================================
            // ÚLTIMO CICLO REAL
            // =====================================================
            /*
             * Cuando un cobro queda PENDING o REJECTED normalmente todavía
             * no existe una boleta descargable. Ese estado llega directamente
             * en planPagos:
             *
             * subs_his_number_cicle
             * subs_his_date_payment
             * subs_his_payment_status
             * subs_his_attempt_number
             *
             * Si el ciclo ya apareció en listBoletas no se duplica.
             */
            const latestRawStatus = String(paymentPlan?.subs_his_payment_status || '').trim().toUpperCase();
            const latestRawCycle = paymentPlan?.subs_his_number_cicle;
            const latestCycle = latestRawCycle === null
                || latestRawCycle === undefined
                || latestRawCycle === ''
                ? null
                : Number(latestRawCycle);
            const hasValidLatestStatus = latestRawStatus === 'APPROVED'
                || latestRawStatus === 'PENDING'
                || latestRawStatus === 'REJECTED';
            const cycleAlreadyAdded = latestCycle !== null
                && Number.isFinite(latestCycle)
                && processedCycles.has(latestCycle);
            if (hasValidLatestStatus && !cycleAlreadyAdded) {
                const latestRawDate = paymentPlan?.subs_his_date_payment || null;
                const latestAttemptNumber = Number(paymentPlan?.subs_his_attempt_number || 0);
                const latestStatusData = this.getPaymentHistoryStatusData(latestRawStatus);
                history.push({
                    rowType: 'REAL',
                    isProjected: false,
                    sub_tic_id: 0,
                    subs_id: Number(paymentPlan?.subs_id || 0),
                    sub_pay_id: Number(paymentPlan?.sub_pay_id || 0),
                    cycle: latestCycle,
                    rawDate: latestRawDate,
                    date: this.formatDateToDisplay(latestRawDate),
                    amount: Number(paymentPlan?.sub_pay_total_amount || 0),
                    rawStatus: latestRawStatus,
                    status: latestStatusData.status,
                    statusLabel: latestStatusData.statusLabel,
                    statusDetail: this.getPaymentStatusDetail(latestRawStatus, latestAttemptNumber, latestCycle),
                    attemptNumber: latestAttemptNumber,
                    receiptAvailable: false,
                    receipt: null,
                    provider: paymentPlan?.sub_pay_provider || '',
                    canRegularize: this.canRegularizePayment(latestRawStatus, latestAttemptNumber, paymentPlan?.sub_pay_provider),
                    nextPayment: false
                });
                if (latestCycle !== null && Number.isFinite(latestCycle)) {
                    processedCycles.add(latestCycle);
                }
            }
        });
        return history;
    }
    private getPaymentHistoryStatusData(rawStatus: any): {
        status: 'PAID' | 'RETRY' | 'REJECTED' | 'SCHEDULED';
        statusLabel: string;
    } {
        const status = String(rawStatus || '').trim().toUpperCase();
        switch (status) {
            case 'APPROVED':
                return { status: 'PAID', statusLabel: 'Pagado' };
            case 'PENDING':
                return { status: 'RETRY', statusLabel: 'En reintento' };
            case 'REJECTED':
                return { status: 'REJECTED', statusLabel: 'Rechazada' };
            default:
                return { status: 'SCHEDULED', statusLabel: 'Pendiente' };
        }
    }
    private getPaymentStatusDetail(rawStatus: any, attemptNumber: number, cycle: number | null): string {
        const status = String(rawStatus || '').trim().toUpperCase();
        const attempt = Number(attemptNumber || 0);
        if (status === 'PENDING') {
            return attempt > 0
                ? `Intento ${Math.min(attempt, 4)} de 4`
                : 'Mercado Pago realizará nuevos intentos';
        }
        if (status === 'REJECTED') {
            return attempt > 0
                ? `Cobro rechazado · ${attempt} ${attempt === 1 ? 'intento' : 'intentos'}`
                : 'Cobro rechazado';
        }
        if (status === 'APPROVED') {
            return cycle !== null ? `Ciclo ${cycle}` : 'Pago realizado';
        }
        return '';
    }
    private canRegularizePayment(rawStatus: any, attemptNumber: any, provider: any): boolean {
        const status = String(rawStatus || '').trim().toUpperCase();
        const attempts = Number(attemptNumber || 0);
        const paymentProvider = String(provider || '').trim().toUpperCase();
        return this.isSupportedRegularizationProvider(paymentProvider)
            && attempts >= 4
            && (status === 'PENDING' || status === 'REJECTED');
    }

    private isSupportedRegularizationProvider(provider: any): boolean {
        const normalizedProvider = this.cleanString(provider).toUpperCase();
        return normalizedProvider === 'MERCADO_PAGO'
            || normalizedProvider === 'VIRTUAL_POS';
    }

    public getRegularizationProviderLabel(plan: any = this.plan_selected): string {
        const provider = this.getPaymentProvider(plan);

        if (provider === 'VIRTUAL_POS') {
            return 'VirtualPOS';
        }

        if (provider === 'MERCADO_PAGO') {
            return 'Mercado Pago';
        }

        return 'Proveedor de pago';
    }

    public getRegularizationPaymentButtonLabel(plan: any = this.plan_selected): string {
        return `Pagar con ${this.getRegularizationProviderLabel(plan)}`;
    }

    public getRegularizationPendingMessage(plan: any = this.plan_selected): string {
        const providerLabel = this.getRegularizationProviderLabel(plan);
        return `${providerLabel} está procesando la transacción. Esta ventana se actualizará automáticamente cuando recibamos el resultado final.`;
    }

    public getRegularizationWaitingMessage(plan: any = this.plan_selected): string {
        const providerLabel = this.getRegularizationProviderLabel(plan);
        return `Completa el pago en la pestaña de ${providerLabel}. Esta ventana se actualizará automáticamente cuando recibamos la confirmación.`;
    }

    /**
     * Obtiene las cuotas que ya agotaron los intentos automáticos y pueden
     * regularizarse mediante un pago único del proveedor correspondiente.
     */
    private getRegularizableDebtCharges(plan: any): any[] {
        const paymentPlan = this.getPaymentPlan(plan);
        const charges = Array.isArray(paymentPlan?.charges) ? paymentPlan.charges : [];
        const debtByCycle = new Map<string, any>();

        charges.forEach((charge: any, index: number) => {
            const rawCycle = charge?.nroCiclo;
            const cycle = Number(rawCycle);
            const status = String(charge?.statusPago || '').trim().toUpperCase();
            const attempts = Number(charge?.numberAttemp || 0);

            // El ciclo 0 corresponde a días gratis y nunca genera deuda.
            if (!Number.isFinite(cycle) || cycle <= 0) return;
            if ((status !== 'PENDING' && status !== 'REJECTED') || attempts < 4) return;

            debtByCycle.set(String(cycle || index), charge);
        });

        return Array.from(debtByCycle.values());
    }

    public getPendingDebtCount(plan: any): number {
        const debtCharges = this.getRegularizableDebtCharges(plan);
        if (debtCharges.length > 0) return debtCharges.length;

        // Fallback para respuestas antiguas que todavía no incluyen charges[].
        const paymentPlan = this.getPaymentPlan(plan);
        const status = String(paymentPlan?.subs_his_payment_status || '').trim().toUpperCase();
        const attempts = Number(paymentPlan?.subs_his_attempt_number || 0);

        return (status === 'PENDING' || status === 'REJECTED') && attempts >= 4 ? 1 : 0;
    }

    public getPendingDebtLabel(plan: any): string {
        const count = this.getPendingDebtCount(plan);
        return count === 1 ? '1 cuota impaga' : `${count} cuotas impagas`;
    }

    public hasPendingDebtToRegularize(plan: any): boolean {
        const paymentPlan = this.getPaymentPlan(plan);
        const provider = this.getPaymentProvider(plan);

        return this.isSupportedRegularizationProvider(provider)
            && Number(paymentPlan?.subs_id || 0) > 0
            && this.getPendingDebtCount(plan) > 0;
    }

    public async openRegularizePaymentModal(): Promise<void> {
        if (this.generatingRegularizePayment) return;

        if (!this.hasPendingDebtToRegularize(this.plan_selected)) {
            Swal.fire({
                icon: 'info',
                title: 'No hay deuda disponible para regularizar',
                text: 'No encontramos cuotas vencidas habilitadas para pago único en esta suscripción.',
                confirmButtonText: 'Aceptar'
            });
            return;
        }

        const paymentPlan = this.getPaymentPlan(this.plan_selected);
        const subsId = Number(paymentPlan?.subs_id || 0);
        const providerPay = this.getPaymentProvider(this.plan_selected);

        if (!subsId) {
            Swal.fire({
                icon: 'warning',
                title: 'Suscripción no identificada',
                text: 'No fue posible obtener el identificador de la suscripción.',
                confirmButtonText: 'Aceptar'
            });
            return;
        }

        if (!this.isSupportedRegularizationProvider(providerPay)) {
            Swal.fire({
                icon: 'warning',
                title: 'Proveedor de pago no disponible',
                text: 'No fue posible identificar un proveedor compatible para regularizar esta suscripción.',
                confirmButtonText: 'Aceptar'
            });
            return;
        }

        // Evita crear una nueva orden si el usuario cerró y volvió a abrir el modal.
        if (Number(this.paymentToRegularize?.subsId || 0) === subsId
            && this.cleanString(this.paymentToRegularize?.providerPay).toUpperCase() === providerPay
            && this.cleanString(this.paymentToRegularize?.checkout_url)) {
            this.resetRegularizationPaymentState(false);
            this.showRegularizePaymentModal = true;
            return;
        }

        this.generatingRegularizePayment = true;
        this.paymentToRegularize = null;
        this.resetRegularizationPaymentState(false);

        try {
            const response: any = await this.inscripcionConvenioService.postGeneratePayButton({
                subsId,
                providerPay
            });

            const checkoutUrl = this.cleanString(response?.checkout_url);
            const amount = Number(response?.amount || 0);

            if (!this.parseBooleanValue(response?.status)) {
                throw new Error(response?.message || 'No fue posible generar el pago de regularización.');
            }

            if (!checkoutUrl || !Number.isFinite(amount) || amount <= 0) {
                throw new Error('La respuesta del proveedor de pago no contiene una URL o monto válido.');
            }

            this.paymentToRegularize = {
                ...response,
                subsId,
                providerPay,
                amount,
                checkout_url: checkoutUrl
            };
            this.showRegularizePaymentModal = true;
        } catch (error) {
            console.error('[PlansComponent] Error generando pago de regularización:', error);
            Swal.fire({
                icon: 'error',
                title: 'No fue posible generar el pago',
                text: this.getBackendErrorMessage(
                    error,
                    `Ocurrió un problema al preparar el pago único con ${this.getRegularizationProviderLabel(this.plan_selected)}. Intenta nuevamente.`
                ),
                confirmButtonText: 'Aceptar'
            });
        } finally {
            this.generatingRegularizePayment = false;
        }
    }

    public closeRegularizePaymentModal(): void {
        // Mientras esperamos la confirmación no cerramos el modal por accidente.
        if (this.regularizationWaitingPayment) return;

        this.showRegularizePaymentModal = false;
        this.resetRegularizationPaymentState(true);
    }

    public goToRegularizePaymentCheckout(): void {
        const checkoutUrl = this.cleanString(this.paymentToRegularize?.checkout_url);

        if (!checkoutUrl) {
            Swal.fire({
                icon: 'warning',
                title: 'Pago no disponible',
                text: 'No se encontró el enlace de pago. Cierra esta ventana e intenta nuevamente.',
                confirmButtonText: 'Aceptar'
            });
            return;
        }

        this.regularizationError = '';
        this.regularizationSuccess = false;
        this.regularizationPending = false;

        // Abrimos el proveedor de pago en una pestaña nueva y AlmaMedis mantiene
        // el mismo estado del modal mientras se procesa la regularización.
        const paymentWindow = window.open(checkoutUrl, '_blank');

        if (!paymentWindow) {
            this.regularizationWaitingPayment = false;
            this.regularizationError = `El navegador bloqueó la pestaña de ${this.getRegularizationProviderLabel(this.plan_selected)}. Habilita las ventanas emergentes e inténtalo nuevamente.`;
            return;
        }

        try {
            paymentWindow.opener = null;
        } catch (_) {
            // Algunos navegadores no permiten modificar opener. No afecta el flujo.
        }

        this.regularizationWaitingPayment = true;
    }

    public async retryRegularizePayment(): Promise<void> {
        if (this.regularizationWaitingPayment || this.generatingRegularizePayment) return;

        this.showRegularizePaymentModal = false;
        this.resetRegularizationPaymentState(true);
        await this.openRegularizePaymentModal();
    }

    private resetRegularizationPaymentState(clearPayment: boolean = false): void {
        this.regularizationWaitingPayment = false;
        this.regularizationPending = false;
        this.regularizationSuccess = false;
        this.regularizationError = '';

        if (clearPayment) {
            this.paymentToRegularize = null;
        }
    }

    /**
     * Se mantiene para compatibilidad con cualquier botón de regularización
     * que todavía utilice el objeto de una fila del historial.
     */
    public regularizePayment(payment?: any): void {
        if (payment && payment?.canRegularize === false) return;
        void this.openRegularizePaymentModal();
    }
    // =========================================================
    // PAGOS FUTUROS SIMULADOS
    // =========================================================
    private buildProjectedPaymentHistory(plan: any, realRows: any[]): any[] {
        /*
         * Si el usuario tiene una baja completa
         * programada, no proyectamos cobros posteriores.
         */
        if (this.hasCancelSubscriptionFutureRequest(plan)) {
            return [];
        }
        const paymentPlan = this.getPaymentPlan(plan);
        if (!paymentPlan
            || Object.keys(paymentPlan).length === 0) {
            return [];
        }
        // =======================================================
        // PRÓXIMA FECHA REAL DE FACTURACIÓN
        // =======================================================
        /*
         * IMPORTANTE:
         *
         * Ya NO se utiliza subs_facturation_date
         * como primera prioridad.
         *
         * Para Mercado Pago usamos:
         *
         * auto_recurring.billing_day
         *
         * Ejemplo:
         *
         * billing_day = 24
         * última boleta = 24/08/2026
         *
         * próxima proyección = 24/09/2026
         */
        const nextBillingDate = this.getNextProjectedBillingDate(plan, realRows);
        if (!nextBillingDate) {
            return [];
        }
        // =======================================================
        // FIN DE VIGENCIA
        // =======================================================
        const planEndDate = this.parsePlanDate(plan?.cus_dat_to_date);
        if (planEndDate
            && nextBillingDate > planEndDate) {
            return [];
        }
        // =======================================================
        // CAMBIOS PROGRAMADOS
        // =======================================================
        const futureRequests = this.getFutureChangeRequests(plan);
        const projectedBeneficiaryCount = this.getNextCycleBeneficiaryCount(plan);
        // =======================================================
        // MONTO FUTURO
        // =======================================================
        const calculatedProjectedAmount = this.getPlanMonthlyAmountByBeneficiaryCountForPlan(plan, projectedBeneficiaryCount);
        const projectedAmount = calculatedProjectedAmount > 0
            ? calculatedProjectedAmount
            : Number(paymentPlan?.sub_pay_total_amount
                || 0);
        // =======================================================
        // CICLO
        // =======================================================
        const currentCycle = this.getHighestPaymentCycle(realRows, paymentPlan);
        let nextCycle = currentCycle + 1;
        // =======================================================
        // DESCRIPCIÓN
        // =======================================================
        const projectionDetail = this.getPaymentProjectionDetail(plan, futureRequests);
        // =======================================================
        // FILAS PROYECTADAS
        // =======================================================
        const projectedRows: any[] = [];
        let currentDate = new Date(nextBillingDate.getFullYear(), nextBillingDate.getMonth(), nextBillingDate.getDate());
        let generatedPayments = 0;
        const billingDay = this.getBillingDay(paymentPlan, currentDate.getDate());
        while (generatedPayments
            < this.MAX_PROJECTED_PAYMENTS
            &&
                (!planEndDate
                    || currentDate <= planEndDate)) {
            projectedRows.push({
                rowType: 'PROJECTED',
                isProjected: true,
                sub_tic_id: null,
                subs_id: Number(paymentPlan?.subs_id
                    || 0),
                sub_pay_id: Number(paymentPlan?.sub_pay_id
                    || 0),
                cycle: nextCycle,
                rawDate: new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()),
                date: this.formatDateToDisplay(currentDate),
                amount: projectedAmount,
                status: 'SCHEDULED',
                statusLabel: 'Simulado',
                statusDetail: projectionDetail,
                detail: projectionDetail,
                projectedBeneficiaryCount: projectedBeneficiaryCount,
                projectedRequestsCount: futureRequests.length,
                receiptAvailable: false,
                receipt: null,
                provider: paymentPlan?.sub_pay_provider
                    || '',
                canRegularize: false,
                nextPayment: true
            });
            // =====================================================
            // SIGUIENTE MES
            // =====================================================
            /*
             * Cada fecha se vuelve a construir
             * utilizando el billing_day.
             *
             * Esto evita perder el día original
             * en meses con menos días.
             */
            currentDate =
                this.buildDateWithBillingDay(currentDate.getFullYear(), currentDate.getMonth() + 1, billingDay);
            nextCycle++;
            generatedPayments++;
        }
        return projectedRows;
    }
    // =========================================================
    // OBTENER PRÓXIMA FECHA DE FACTURACIÓN
    // =========================================================
    private getNextProjectedBillingDate(plan: any, realRows: any[]): Date | null {
        const paymentPlan = this.getPaymentPlan(plan);
        if (!paymentPlan
            || Object.keys(paymentPlan).length === 0) {
            return null;
        }
        const providerResponse = paymentPlan?.sub_pay_provider_response
            || {};
        const autoRecurring = providerResponse?.auto_recurring
            || {};
        // =======================================================
        // ÚLTIMA FACTURACIÓN REAL
        // Incluye APPROVED, PENDING y REJECTED.
        // =======================================================
        const lastRealDate = this.getLastRealPaymentDate(realRows);
        // =======================================================
        // BILLING DAY MERCADO PAGO
        // =======================================================
        const hasBillingDay = this.parseBooleanValue(autoRecurring?.has_billing_day);
        const billingDay = Number(autoRecurring?.billing_day);
        if (hasBillingDay
            && Number.isFinite(billingDay)
            && billingDay >= 1
            && billingDay <= 31) {
            // =====================================================
            // CON FACTURACIONES REALES
            // =====================================================
            if (lastRealDate) {
                /*
                 * Primero intentamos construir la fecha
                 * correspondiente al mismo mes del última facturación.
                 */
                let candidate = this.buildDateWithBillingDay(lastRealDate.getFullYear(), lastRealDate.getMonth(), billingDay);
                /*
                 * Si el billing day ya ocurrió
                 * o corresponde al mismo día del última facturación,
                 * avanzamos al mes siguiente.
                 */
                if (candidate <= lastRealDate) {
                    candidate =
                        this.buildDateWithBillingDay(lastRealDate.getFullYear(), lastRealDate.getMonth() + 1, billingDay);
                }
                return candidate;
            }
            // =====================================================
            // SIN BOLETAS - NEXT PAYMENT DATE
            // =====================================================
            const nextPaymentDate = this.parsePlanDate(providerResponse?.next_payment_date);
            if (nextPaymentDate) {
                let candidate = this.buildDateWithBillingDay(nextPaymentDate.getFullYear(), nextPaymentDate.getMonth(), billingDay);
                /*
                 * Si next_payment_date por alguna razón
                 * queda antes del día esperado, calculamos
                 * el mes siguiente.
                 */
                if (candidate < nextPaymentDate) {
                    candidate =
                        this.buildDateWithBillingDay(nextPaymentDate.getFullYear(), nextPaymentDate.getMonth() + 1, billingDay);
                }
                return candidate;
            }
            // =====================================================
            // SIN BOLETAS - START DATE
            // =====================================================
            const startDate = this.parsePlanDate(autoRecurring?.start_date);
            if (startDate) {
                return this.buildNextBillingDate(startDate, billingDay);
            }
        }
        // =======================================================
        // FALLBACK
        // =======================================================
        /*
         * Solamente si Mercado Pago no posee
         * billing_day utilizable recurrimos
         * a las fechas alternativas.
         */
        let fallbackDate = this.parsePlanDate(providerResponse?.next_payment_date
            || paymentPlan?.subs_facturation_date);
        if (!fallbackDate) {
            return null;
        }
        /*
         * Si la fecha fallback ya ocurrió
         * respecto a la última boleta,
         * avanzamos un mes.
         */
        if (lastRealDate
            && fallbackDate <= lastRealDate) {
            fallbackDate =
                this.addMonthsPreservingDay(fallbackDate, 1);
        }
        return fallbackDate;
    }
    // =========================================================
    // BILLING DAY
    // =========================================================
    private getBillingDay(paymentPlan: any, fallbackDay: number = 1): number {
        const billingDay = Number(paymentPlan
            ?.sub_pay_provider_response
            ?.auto_recurring
            ?.billing_day);
        if (Number.isFinite(billingDay)
            && billingDay >= 1
            && billingDay <= 31) {
            return billingDay;
        }
        return Math.min(Math.max(Number(fallbackDay) || 1, 1), 31);
    }
    // =========================================================
    // ÚLTIMA FECHA PAGADA
    // =========================================================
    // =========================================================
    // ÚLTIMA FACTURACIÓN REAL
    // =========================================================
    private getLastRealPaymentDate(realRows: any[]): Date | null {
        let latestDate: Date | null = null;
        (realRows || []).forEach((payment: any) => {
            const date = this.parsePlanDate(payment?.rawDate);
            if (!date)
                return;
            if (!latestDate || date > latestDate) {
                latestDate = date;
            }
        });
        return latestDate;
    }
    // =========================================================
    // ÚLTIMO CICLO REAL
    // =========================================================
    private getHighestPaymentCycle(realRows: any[], paymentPlan: any): number {
        const cycles: number[] = [];
        (realRows || [])
            .forEach((payment: any) => {
            if (payment?.cycle === null
                || payment?.cycle === undefined
                || payment?.cycle === '') {
                return;
            }
            const cycle = Number(payment.cycle);
            if (Number.isFinite(cycle)) {
                cycles.push(cycle);
            }
        });
        const paymentPlanCycle = Number(paymentPlan?.subs_his_number_cicle);
        if (Number.isFinite(paymentPlanCycle)) {
            cycles.push(paymentPlanCycle);
        }
        if (cycles.length === 0) {
            return 0;
        }
        return Math.max(...cycles);
    }
    // =========================================================
    // DESCRIPCIÓN PROYECCIÓN
    // =========================================================
    private getPaymentProjectionDetail(plan: any, requests: any[]): string {
        if (!requests
            || requests.length === 0) {
            return 'Cobro mensual estimado';
        }
        const delta = this.getFutureRequestsSlotDelta(plan);
        if (delta > 0) {
            return delta === 1
                ? 'Incluye 1 cupo adicional programado'
                : `Incluye ${delta} cupos adicionales programados`;
        }
        if (delta < 0) {
            const quantity = Math.abs(delta);
            return quantity === 1
                ? 'Considera 1 cupo menos en el próximo ciclo'
                : `Considera ${quantity} cupos menos en el próximo ciclo`;
        }
        return 'Considera los cambios programados del plan';
    }
    // =========================================================
    // URL BOLETA
    // =========================================================
    public getReceiptUrl(payment: any): string {
        const path = String(
            payment?.boleta
            || payment?.receipt?.sub_tic_path_file
            || ''
        ).trim();

        if (!path) {
            return '';
        }

        if (/^https?:\/\//i.test(path)) {
            return path;
        }

        const baseUrl = String(this.URL_DOCS || '').replace(/\/+$/, '');
        const normalizedPath = path.startsWith('/') ? path : `/${path}`;

        return `${baseUrl}${normalizedPath}`;
    }

    private getReceiptFileName(payment: any): string {
        const path = String(
            payment?.boleta
            || payment?.receipt?.sub_tic_path_file
            || ''
        ).trim();

        const pathFileName = path
            .split('/')
            .filter((value: string) => !!value)
            .pop();

        if (pathFileName) {
            return pathFileName;
        }

        const cycle = payment?.cycle !== null && payment?.cycle !== undefined
            ? payment.cycle
            : '';

        return cycle !== ''
            ? `boleta-ciclo-${cycle}.pdf`
            : 'boleta-almamedis.pdf';
    }

    private getReceiptDownloadKey(payment: any): string {
        return String(
            payment?.downloadKey
            || `${payment?.subs_id || 'plan'}_${payment?.cycle ?? 'ciclo'}_${payment?.boleta || ''}`
        );
    }

    // =========================================================
    // DESCARGAR BOLETA
    // =========================================================
    public async downloadReceipt(payment: any): Promise<void> {
        const downloadKey = this.getReceiptDownloadKey(payment);

        if (this.downloadingReceiptIds.has(downloadKey)) {
            return;
        }

        const url = this.getReceiptUrl(payment);

        if (!url) {
            Swal.fire({
                icon: 'warning',
                title: 'Boleta no disponible',
                text: 'No se encontró el archivo asociado a este cargo.',
                confirmButtonText: 'Aceptar'
            });
            return;
        }

        try {
            this.downloadingReceiptIds.add(downloadKey);

            const response = await fetch(url, {
                method: 'GET'
            });

            if (!response.ok) {
                throw new Error(`Error descargando boleta. HTTP ${response.status}`);
            }

            const blob = await response.blob();
            const blobUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');

            link.href = blobUrl;
            link.download = this.getReceiptFileName(payment);
            link.style.display = 'none';

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl);
        } catch (error) {
            console.error('[PlansComponent] Error descargando boleta:', error);
            window.open(url, '_blank');
        } finally {
            this.downloadingReceiptIds.delete(downloadKey);
        }
    }

    public isDownloadingReceipt(payment: any): boolean {
        return this.downloadingReceiptIds.has(
            this.getReceiptDownloadKey(payment)
        );
    }

    public getPaymentHistoryStatusClass(payment: any): string {
        switch (payment?.status) {
            case 'PAID':
                return 'payment-status-paid';
            case 'REJECTED':
                return 'payment-status-rejected';
            case 'RETRY':
                return 'payment-status-retry';
            case 'SCHEDULED':
                return 'payment-status-scheduled';
            default:
                return 'payment-status-scheduled';
        }
    }
    public hasProjectedPaymentHistory(): boolean {
        return (this.paymentHistoryRows || []).some((payment: any) => payment?.isProjected === true);
    }
    public getProjectedPaymentHistoryRow(): any {
        return (this.paymentHistoryRows || []).find((payment: any) => payment?.isProjected === true) || null;
    }
    // =========================================================
    // FORM BENEFICIARIO
    // =========================================================
    private initBeneficiaryForm(): void {
        this.beneficiaryForm =
            this.createBeneficiaryForm();
        this.setBeneficiaryTelefonoValidators(this.selectedBeneficiaryAreaCode);
    }
    private createBeneficiaryForm(data?: any): FormGroup {
        return this.fb.group({
            use_rut: [
                data?.use_rut || '',
                [
                    Validators.required,
                    this.rutChilenoValidator.bind(this),
                    this.beneficiaryRutPlanValidator.bind(this)
                ]
            ],
            use_name: [
                data?.use_name || '',
                [
                    Validators.required,
                    Validators.minLength(2)
                ]
            ],
            use_paternal_surname: [
                data?.use_paternal_surname || '',
                [
                    Validators.required,
                    Validators.minLength(2)
                ]
            ],
            use_maternal_surname: [
                data?.use_maternal_surname || ''
            ],
            use_email: [
                data?.use_email || '',
                [
                    Validators.required,
                    this.emailFormatoValidator
                ]
            ],
            phone_code: [
                data?.phone_code || '56',
                Validators.required
            ],
            use_phone: [
                data?.use_phone || '',
                [
                    Validators.required,
                    Validators.pattern('^[0-9]*$')
                ]
            ],
            use_birthdate: [
                data?.use_birthdate || '',
                [
                    Validators.required,
                    this.fechaNoFuturaValidator
                ]
            ],
            relationship: [
                data?.relationship || ''
            ]
        });
    }
    // =========================================================
    // PAÍSES
    // =========================================================
    private getCodPaises(): void {
        this.usuarioService
            .getCodPaises()
            .then((data: any) => {
            const codigos = Array.isArray(data)
                ? data
                : Array.isArray(data?.data)
                    ? data.data
                    : [];
            this.areaCodes =
                codigos.length > 0
                    ? codigos
                    : this.areaCodes;
            const codigoChile = this.areaCodes.find((item: any) => {
                return String(item.cou_phone_code) === '56';
            });
            this.selectedBeneficiaryAreaCode =
                codigoChile
                    || this.selectedBeneficiaryAreaCode;
            this.beneficiaryForm.patchValue({
                phone_code: this.selectedBeneficiaryAreaCode
                    .cou_phone_code
            }, {
                emitEvent: false
            });
            this.setBeneficiaryTelefonoValidators(this.selectedBeneficiaryAreaCode);
        })
            .catch((error: any) => {
            console.error('Error getCodPaises:', error);
            this.setBeneficiaryTelefonoValidators(this.selectedBeneficiaryAreaCode);
        });
    }
    // =========================================================
    // LISTAR PLANES
    // =========================================================
    public async postListPlansXBeneficiaries(): Promise<any[]> {
        this.loadingPlans = true;
        try {
            const result: any = await this.generalService
                .postListPlansXBeneficiaries(this.usuario.use_id);
            this.planes =
                Array.isArray(result)
                    ? result
                    : (result?.data
                        || []);
            return this.planes;
        }
        catch (error: any) {
            console.error('Error postListPlansXBeneficiaries:', error);
            this.planes = [];
            return [];
        }
        finally {
            this.loadingPlans = false;
        }
    }
    // =========================================================
    // NAVEGACIÓN PLAN
    // =========================================================
    public getPlanTabsGridTemplate(): string {
        if (!this.plan_selected?.is_titular) return '1fr';
        if (!this.plan_selected?.cus_ben_is_suscription) return 'repeat(2, 1fr)';
        return this.showPaymentHistoryTab ? 'repeat(4, 1fr)' : 'repeat(3, 1fr)';
    }

    public showPlan(plan: any): void {
        this.plan_selected =
            plan || {};
        this.paymentToRegularize = null;
        this.showRegularizePaymentModal = false;
        this.generatingRegularizePayment = false;
        this.resetRegularizationPaymentState(false);
        this.currentView =
            'detail';
        this.activeDetailTab =
            'detail';
        this.showAllSpecialties =
            false;
        this.closeBeneficiaryModal();
        this.setBeneficiariesWorkingFromPlan();
        /*
         * Genera el historial desde planPagos[].charges solo si el TAB está habilitado.
         */
        if (this.showPaymentHistoryTab) {
            this.refreshPaymentHistory();
        }
    }
    public backToList(): void {
        this.currentView =
            'list';
        this.plan_selected =
            {};
        this.activeDetailTab =
            'detail';
        this.showAllSpecialties =
            false;
        this.modifyingConvenio =
            false;
        this.closeTermsAndConditionsModal();
        this.closeBeneficiaryModal();
        this.closeDeleteBeneficiaryConfirmModal();
        this.closeCancelFutureRequestConfirmModal();
        this.closeCancelSubscriptionConfirmModal();
        this.closePlanChangeComparisonModal();
        this.beneficiariesWorking =
            [];
        this.originalBeneficiariesModifySnapshot =
            [];
        this.beneficiariesBeforeLastChange =
            [];
        this.originalBeneficiarySlotCount =
            0;
        this.modifiedBeneficiarySlotCount =
            0;
        this.beneficiarySlotCountBeforeLastChange =
            0;
        this.addingNewSlotInModify =
            false;
        this.editingExistingEmptySlot =
            false;
        this.pendingModifyPlanSubsPayload =
            null;
        this.pendingModifyPlanOriginalPlan =
            null;
        this.paymentHistoryRows =
            [];
        this.paymentToRegularize = null;
        this.showRegularizePaymentModal = false;
        this.generatingRegularizePayment = false;
        this.resetRegularizationPaymentState(false);
    }
    public goToDetail(): void {
        this.currentView =
            'detail';
        this.activeDetailTab =
            'detail';
        this.closeBeneficiaryModal();
    }
    public setActiveDetailTab(tab: DetailTab): void {
        if (tab === 'paymentHistory' && !this.showPaymentHistoryTab) {
            this.activeDetailTab = 'detail';
            return;
        }
        this.activeDetailTab =
            tab;
        this.closeBeneficiaryModal();
        if (tab === 'beneficiaries') {
            this.setBeneficiariesWorkingFromPlan();
        }
        if (tab === 'paymentHistory') {
            /*
             * Recalculamos porque las solicitudes
             * programadas pudieron cambiar.
             */
            this.refreshPaymentHistory();
        }
    }
    public goToBeneficiariesTab(): void {
        this.currentView =
            'detail';
        this.activeDetailTab =
            'beneficiaries';
        this.modifyingConvenio =
            false;
        this.setBeneficiariesWorkingFromPlan();
        this.closeBeneficiaryModal();
        this.closeDeleteBeneficiaryConfirmModal();
        this.closeCancelFutureRequestConfirmModal();
        this.closeCancelSubscriptionConfirmModal();
        this.closePlanChangeComparisonModal();
    }
    public openBeneficiariesFromPlan(plan: any): void {
        this.plan_selected =
            plan || {};
        this.currentView =
            'detail';
        this.activeDetailTab =
            'beneficiaries';
        this.modifyingConvenio =
            false;
        this.showAllSpecialties =
            false;
        this.closeBeneficiaryModal();
        this.closeDeleteBeneficiaryConfirmModal();
        this.closeCancelFutureRequestConfirmModal();
        this.closeCancelSubscriptionConfirmModal();
        this.closePlanChangeComparisonModal();
        this.setBeneficiariesWorkingFromPlan();
    }
    // =========================================================
    // MODIFICAR PLAN
    // =========================================================
    public modifyPlan(plan?: any): void {
        if (plan) {
            this.plan_selected =
                plan;
        }
        this.currentView =
            'detail';
        this.activeDetailTab =
            'configuration';
        this.startModifyConvenio();
    }
    public startModifyConvenio(): void {
    if (!this.canModifyConvenio(this.plan_selected)) return;
    if (!this.canAddBeneficiaries(this.plan_selected)) return;

    this.modifyingConvenio = true;
    this.activeDetailTab = 'configuration';
    this.setBeneficiariesWorkingFromPlan();

    const totalSlotsPlan = this.getBeneficiaryLimit(this.plan_selected);
    const totalBeneficiariosReales = this.beneficiariesWorking.length;

    this.originalBeneficiarySlotCount = Math.max(totalSlotsPlan, totalBeneficiariosReales);
    this.modifiedBeneficiarySlotCount = this.originalBeneficiarySlotCount;
    this.beneficiarySlotCountBeforeLastChange = this.modifiedBeneficiarySlotCount;
    this.originalBeneficiariesModifySnapshot = this.cloneBeneficiaries(this.beneficiariesWorking);
    this.beneficiariesBeforeLastChange = this.cloneBeneficiaries(this.beneficiariesWorking);

    this.closeBeneficiaryModal();
    this.closeDeleteBeneficiaryConfirmModal();
    this.closeCancelFutureRequestConfirmModal();
    this.closeCancelSubscriptionConfirmModal();
    this.closePlanChangeComparisonModal();
}
    public cancelModifyConvenio(): void {
        this.beneficiariesWorking =
            this.cloneBeneficiaries(this.originalBeneficiariesModifySnapshot);
        this.modifiedBeneficiarySlotCount =
            this.originalBeneficiarySlotCount;
        this.beneficiarySlotCountBeforeLastChange =
            this.originalBeneficiarySlotCount;
        this.updateSelectedPlanBeneficiariesLocal();
        this.modifyingConvenio =
            false;
        this.activeDetailTab =
            'configuration';
        this.addingNewSlotInModify =
            false;
        this.editingExistingEmptySlot =
            false;
        this.pendingModifyPlanSubsPayload =
            null;
        this.pendingModifyPlanOriginalPlan =
            null;
        this.closeBeneficiaryModal();
        this.closeDeleteBeneficiaryConfirmModal();
        this.closeCancelFutureRequestConfirmModal();
        this.closePlanChangeComparisonModal();
    }
    public continueModifyConvenio(): void {
        this.openPlanChangeComparisonModal('FINAL');
    }
    // =========================================================
    // AGREGAR BENEFICIARIO EN MODIFICACIÓN
    // =========================================================
    public openAddBeneficiaryForModify(): void {
        if (!this.canAddBeneficiaries(this.plan_selected)
            || this.hasCancelSubscriptionFutureRequest(this.plan_selected)) {
            return;
        }
        const tieneSlotsDisponibles = this.hasAvailableSlotsToFillInModify();
        this.addingNewSlotInModify =
            !tieneSlotsDisponibles;
        this.editingExistingEmptySlot =
            tieneSlotsDisponibles;
        this.editingBeneficiaryIndex =
            null;
        this.resetBeneficiaryForm();
        this.showBeneficiaryForm =
            true;
        this.showBeneficiaryModal =
            true;
    }
    public openEditBeneficiaryForModify(beneficiary: any, index: number | null): void {
        if (!this.canAddBeneficiaries(this.plan_selected)) {
            return;
        }
        if (index === null
            || index === undefined
            || index < 0
            || !beneficiary) {
            return;
        }
        this.editingBeneficiaryIndex =
            index;
        this.editingExistingEmptySlot =
            false;
        const phoneData = this.getPhoneDataFromBeneficiary(beneficiary);
        this.selectedBeneficiaryAreaCode =
            phoneData.areaCode
                || this.selectedBeneficiaryAreaCode;
        this.beneficiaryForm =
            this.createBeneficiaryForm({
                use_rut: beneficiary.use_rut || '',
                use_name: beneficiary.use_name || '',
                use_paternal_surname: beneficiary.use_paternal_surname || '',
                use_maternal_surname: beneficiary.use_maternal_surname || '',
                use_email: beneficiary.use_email || '',
                phone_code: this.selectedBeneficiaryAreaCode
                    .cou_phone_code,
                use_phone: phoneData.phone || '',
                use_birthdate: this.getBirthdateForInput(beneficiary),
                relationship: this.getRelationship(beneficiary) === '—'
                    ? ''
                    : this.getRelationship(beneficiary)
            });
        this.setBeneficiaryTelefonoValidators(this.selectedBeneficiaryAreaCode);
        this.refreshBeneficiaryRutValidation();
        this.showBeneficiaryForm =
            true;
        this.showBeneficiaryModal =
            true;
    }
    public isRutBeneficiaryReadonly(): boolean {
        return this.editingBeneficiaryIndex
            !== null;
    }
    // =========================================================
    // ELIMINAR BENEFICIARIO / CUPO
    // =========================================================
    public requestDeleteBeneficiaryFromModify(beneficiary: any | null, index: number | null, rowIndex?: number, isSlotOnly: boolean = false, actionRequest: 'DEL_SLOT' | 'DEL_SLOT_BEN' | 'DEL_BEN' = 'DEL_BEN'): void {
        if (this.hasCancelSubscriptionFutureRequest(this.plan_selected)) {
            return;
        }
        if (beneficiary
            && this.getFutureDeleteRequestForBeneficiary(this.plan_selected, beneficiary)) {
            return;
        }
        if (isSlotOnly) {
            this.beneficiaryDeleteSelected =
                null;
            this.beneficiaryDeleteIndex =
                null;
            this.beneficiaryDeleteIsSlotOnly =
                true;
            this.beneficiaryDeleteActionRequest =
                'DEL_SLOT';
            this.showDeleteBeneficiaryConfirmModal =
                true;
            return;
        }
        if (index === null
            || index === undefined
            || index < 0
            || !beneficiary) {
            return;
        }
        this.beneficiaryDeleteSelected =
            beneficiary;
        this.beneficiaryDeleteIndex =
            index;
        this.beneficiaryDeleteIsSlotOnly =
            false;
        this.beneficiaryDeleteActionRequest =
            actionRequest;
        this.showDeleteBeneficiaryConfirmModal =
            true;
    }
    public closeDeleteBeneficiaryConfirmModal(): void {
        this.showDeleteBeneficiaryConfirmModal =
            false;
        this.beneficiaryDeleteSelected =
            null;
        this.beneficiaryDeleteIndex =
            null;
        this.beneficiaryDeleteIsSlotOnly =
            false;
        this.beneficiaryDeleteActionRequest =
            'DEL_BEN';
    }
    // =========================================================
    // CANCELAR SOLICITUD FUTURA
    // =========================================================
    public requestCancelFutureRequest(request: any): void {
        if (!request
            || !request.change_id) {
            return;
        }
        this.futureRequestCancelSelected =
            request;
        this.showCancelFutureRequestConfirmModal =
            true;
    }
    public closeCancelFutureRequestConfirmModal(): void {
        this.showCancelFutureRequestConfirmModal =
            false;
        this.futureRequestCancelSelected =
            null;
        this.cancellingFutureRequest =
            false;
    }
    public closeCancelSubscriptionConfirmModal(): void {
        this.showCancelSubscriptionConfirmModal =
            false;
        this.cancellingSubscription =
            false;
    }
    // =========================================================
    // DELTA SOLICITUDES
    // =========================================================
    public getFutureRequestSlotDelta(request: any): number {
        const action = (request?.change_action
            || request?.action_request
            || '')
            .toString()
            .toUpperCase();
        if (action === 'ADD_SLOT'
            || action === 'ADD_SLOT_BEN') {
            return 1;
        }
        if (action === 'DEL_SLOT'
            || action === 'DEL_SLOT_BEN'
            || action === 'REMOVE_SLOT'
            || action === 'DELETE_SLOT') {
            return -1;
        }
        return 0;
    }
    public getFutureRequestsSlotDelta(plan: any): number {
        return this
            .getFutureChangeRequests(plan)
            .reduce((total: number, request: any) => {
            return total
                + this.getFutureRequestSlotDelta(request);
        }, 0);
    }
    public getNextCycleBeneficiaryCount(plan: any): number {
        if (this.hasCancelSubscriptionFutureRequest(plan)) {
            return 0;
        }
        const currentLimit = this.getBeneficiaryLimit(plan);
        const futureDelta = this.getFutureRequestsSlotDelta(plan);
        return Math.max(currentLimit + futureDelta, 0);
    }
    public getNextCycleMonthlyAmount(plan: any): number {
        if (this.hasCancelSubscriptionFutureRequest(plan)) {
            return 0;
        }
        return this
            .getPlanMonthlyAmountByBeneficiaryCountForPlan(plan, this.getNextCycleBeneficiaryCount(plan));
    }
    public getNextCycleMonthlyPrice(plan: any): string {
        return this.formatPrice(this.getNextCycleMonthlyAmount(plan));
    }
    public getCurrentActiveBeneficiarySlots(plan: any): number {
        return this.getBeneficiaryLimit(plan);
    }
    public getCancelFutureRequestCurrentBeneficiaryCount(): number {
        return this.getNextCycleBeneficiaryCount(this.plan_selected);
    }
    public getCancelFutureRequestNewBeneficiaryCount(): number {
        if (this.isCancelSubscriptionFutureRequest(this.futureRequestCancelSelected)) {
            return this.getNextCycleBeneficiaryCountIgnoringCancelSubscription(this.plan_selected);
        }
        const currentCount = this.getCancelFutureRequestCurrentBeneficiaryCount();
        const requestDelta = this.getFutureRequestSlotDelta(this.futureRequestCancelSelected);
        return Math.max(currentCount - requestDelta, 0);
    }
    private getNextCycleBeneficiaryCountIgnoringCancelSubscription(plan: any): number {
        const currentLimit = this.getBeneficiaryLimit(plan);
        const futureDelta = this.getFutureRequestsSlotDelta(plan);
        return Math.max(currentLimit + futureDelta, 0);
    }
    public getCancelFutureRequestCurrentPrice(): string {
        return this.formatPrice(this.getPlanMonthlyAmountByBeneficiaryCount(this.getCancelFutureRequestCurrentBeneficiaryCount()));
    }
    public getCancelFutureRequestNewPrice(): string {
        return this.formatPrice(this.getPlanMonthlyAmountByBeneficiaryCount(this.getCancelFutureRequestNewBeneficiaryCount()));
    }
    private buildCancelFutureRequestPayload(request: any): any {
        const paymentPlan = this.getPaymentPlan(this.plan_selected);
        const nextAmount = this.getPlanMonthlyAmountByBeneficiaryCount(this.getCancelFutureRequestNewBeneficiaryCount());
        return {
            sub_pay_token: this.cleanString(paymentPlan?.sub_pay_token
                || paymentPlan?.sub_pay_authorization_code
                || paymentPlan?.sub_pay_provider_response?.id),
            sub_pay_transaction_id: this.cleanString(paymentPlan?.sub_pay_transaction_id
                || paymentPlan
                    ?.sub_pay_provider_response
                    ?.preapproval_plan_id
                || paymentPlan
                    ?.sub_pay_provider_response
                    ?.id),
            sub_pay_provider: this.getPaymentProvider(this.plan_selected),
            monto: nextAmount,
            subs_id: Number(paymentPlan?.subs_id
                || this.plan_selected?.subs_id
                || 0),
            action_request: 'CANCEL_REQUEST',
            change_id: Number(request?.change_id
                || 0),
            datosBeneficiario: []
        };
    }
    private validateCancelFutureRequestPayload(payload: any): boolean {
        return !!(payload?.sub_pay_token
            && payload?.sub_pay_transaction_id
            && this.isSupportedModificationProvider(payload?.sub_pay_provider)
            && payload?.monto
            && payload?.subs_id
            && payload?.action_request === 'CANCEL_REQUEST'
            && payload?.change_id
            && Array.isArray(payload?.datosBeneficiario)
            && payload.datosBeneficiario.length === 0);
    }
    public async confirmCancelFutureRequest(): Promise<void> {
        if (!this.futureRequestCancelSelected
            || this.cancellingFutureRequest) {
            return;
        }
        const payload = this.buildCancelFutureRequestPayload(this.futureRequestCancelSelected);
        if (!this.validateCancelFutureRequestPayload(payload)) {
            Swal.fire({
                icon: 'warning',
                title: 'Datos incompletos',
                text: 'No fue posible armar la información para cancelar la solicitud. Revisa que exista sub_pay_token, sub_pay_transaction_id, sub_pay_provider, subs_id, monto, change_id y datosBeneficiario vacío.',
                confirmButtonText: 'Aceptar'
            });
            return;
        }
        this.cancellingFutureRequest =
            true;
        Swal.fire({
            allowOutsideClick: false,
            html: `
        <div style="margin: 40px 0;">
          <i
            class="material-icons"
            style="
              color:#2BABB7;
              font-size:58px;
              margin-bottom:25px
            ">
            schedule
          </i>

          <h1
            style="
              font-family:Mulish;
              font-style:normal;
              font-weight:700;
              font-size:24px;
              line-height:32px;
              text-align:center;
              color:#171994;
            ">
            Cancelando solicitud ...
          </h1>
        </div>
      `,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });
        const originalPlan = {
            ...this.plan_selected
        };
        try {
            await this.postModifyPlanByProvider(payload);
            this.closeCancelFutureRequestConfirmModal();
            Swal.close();
            await Swal.fire({
                allowOutsideClick: false,
                html: ' <i class="material-icons" style="color:#171994;font-size: 58px;margin: 20px 40px 10px;">mood</i> <br><br>' +
                    ' <h1 style="font-family: Mulish; font-style: normal; font-weight: 800;font-size: 28px; line-height: 48px; align-items: center; text-align: center; color: #171994;" >Solicitud cancelada exitosamente</h1> <br>' +
                    ' <p style="font-family: Mulish; font-style: normal; font-weight: normal; font-size: 18px; line-height: 24px; text-align: center; color: #000000;" ></p><br>',
                confirmButtonText: 'Aceptar',
                showConfirmButton: false,
                timer: 2500
            });
            await this.refreshSelectedPlanAfterBeneficiarySave(originalPlan);
        }
        catch (error) {
            console.error('Error cancel future request:', error);
            Swal.close();
            Swal.fire({
                icon: 'error',
                title: 'No fue posible cancelar la solicitud',
                text: this.getBackendErrorMessage(error, 'Ocurrió un problema al cancelar la solicitud. Intenta nuevamente.'),
                confirmButtonText: 'Aceptar'
            });
        }
        finally {
            this.cancellingFutureRequest =
                false;
        }
    }
    // =========================================================
    // TEXTOS ELIMINAR BENEFICIARIO
    // =========================================================
    public getDeleteBeneficiaryModalTitle(): string {
        if (this.beneficiaryDeleteActionRequest
            === 'DEL_SLOT') {
            return 'Eliminar cupo disponible';
        }
        if (this.beneficiaryDeleteActionRequest
            === 'DEL_SLOT_BEN') {
            return 'Eliminar cupo y beneficiario';
        }
        return 'Eliminar datos del beneficiario';
    }
    public getDeleteBeneficiaryModalDescription(): string {
        if (this.beneficiaryDeleteActionRequest
            === 'DEL_SLOT') {
            return 'Se eliminará un cupo disponible del plan. Este cambio reducirá la tarifa del próximo ciclo de facturación.';
        }
        if (this.beneficiaryDeleteActionRequest
            === 'DEL_SLOT_BEN') {
            return 'Se eliminará el cupo completo y el beneficiario será desactivado del plan en el próximo ciclo. Este cambio reducirá la tarifa mensual.';
        }
        return 'Se eliminarán los datos del beneficiario, pero el cupo seguirá disponible en el plan. Este cambio no modifica la tarifa mensual.';
    }
    public getDeleteBeneficiaryModalPriceText(): string {
        const currentQuantity = this.getNextCycleBeneficiaryCount(this.plan_selected);
        const nextQuantity = this.getDeleteActionNextBeneficiaryCount();
        if (currentQuantity
            === nextQuantity) {
            return `El valor mensual se mantendrá en ${this.formatPrice(this.getPlanMonthlyAmountByBeneficiaryCount(nextQuantity))}/mes`;
        }
        return `Tu precio final será ${this.formatPrice(this.getPlanMonthlyAmountByBeneficiaryCount(nextQuantity))}/mes`;
    }
    public getDeleteConfirmButtonText(): string {
        if (this.beneficiaryDeleteActionRequest
            === 'DEL_BEN') {
            return 'Eliminar datos';
        }
        return 'Eliminar';
    }
    public getDeleteBeneficiaryModalIcon(): string {
        if (this.beneficiaryDeleteActionRequest
            === 'DEL_BEN') {
            return 'fi fi-rr-eraser';
        }
        return 'fi fi-rr-triangle-warning';
    }
    public shouldShowBeneficiaryPenaltyWarning(): boolean {
        return (this.beneficiaryDeleteActionRequest
            === 'DEL_BEN')
            ||
                (this.beneficiaryDeleteActionRequest
                    === 'DEL_SLOT_BEN');
    }
    public getDeleteCurrentBeneficiaryCount(): number {
        return this.getNextCycleBeneficiaryCount(this.plan_selected);
    }
    public getDeleteNewBeneficiaryCount(): number {
        return this.getDeleteActionNextBeneficiaryCount();
    }
    public getDeleteCurrentPrice(): string {
        return this.formatPrice(this.getPlanMonthlyAmountByBeneficiaryCount(this.getDeleteCurrentBeneficiaryCount()));
    }
    public getDeleteNewPrice(): string {
        return this.formatPrice(this.getPlanMonthlyAmountByBeneficiaryCount(this.getDeleteNewBeneficiaryCount()));
    }
    // =========================================================
    // MODAL CANCELAR SOLICITUD
    // =========================================================
    public getCancelFutureRequestModalTitle(): string {
        if (!this.futureRequestCancelSelected) {
            return 'Cancelar solicitud programada';
        }
        return `Cancelar solicitud: ${this.getFutureRequestTypeLabel(this.futureRequestCancelSelected)}`;
    }
    public getCancelFutureRequestModalDescription(): string {
        const request = this.futureRequestCancelSelected;
        if (!request) {
            return 'Se cancelará la solicitud pendiente seleccionada.';
        }
        const action = this.getFutureRequestAction(request);
        if (action === 'ADD_SLOT') {
            return 'Se cancelará la solicitud de agregar un cupo disponible al próximo ciclo.';
        }
        if (action === 'ADD_SLOT_BEN') {
            return 'Se cancelará la solicitud de agregar un nuevo cupo con beneficiario al próximo ciclo.';
        }
        if (action === 'EDIT_SLOT') {
            return 'Se cancelará la solicitud de completar los datos de un cupo disponible.';
        }
        if (action === 'DEL_SLOT') {
            return 'Se cancelará la solicitud de eliminar un cupo disponible.';
        }
        if (action === 'DEL_SLOT_BEN') {
            return 'Se cancelará la solicitud de eliminar el cupo y desactivar al beneficiario.';
        }
        if (action === 'DEL_BEN') {
            return 'Se cancelará la solicitud de vaciar los datos del beneficiario.';
        }
        if (action === 'CANCEL_SUBSCRIPTION') {
            return 'Se cancelará la solicitud de baja del convenio. El plan continuará activo según sus condiciones actuales.';
        }
        return 'Se cancelará la solicitud pendiente seleccionada.';
    }
    public getCancelFutureRequestConfirmButtonText(): string {
        return this.cancellingFutureRequest
            ? 'Cancelando...'
            : 'Confirmar cancelación';
    }
    private getDeleteActionNextBeneficiaryCount(): number {
        const currentQuantity = this.getNextCycleBeneficiaryCount(this.plan_selected);
        if (this.beneficiaryDeleteActionRequest
            === 'DEL_SLOT'
            || this.beneficiaryDeleteActionRequest
                === 'DEL_SLOT_BEN') {
            return Math.max(currentQuantity - 1, 0);
        }
        return currentQuantity;
    }
    public confirmDeleteBeneficiaryFromModify(): void {
        this.beneficiariesBeforeLastChange =
            this.cloneBeneficiaries(this.beneficiariesWorking);
        const projectedSlotCountBeforeChange = this.getNextCycleBeneficiaryCount(this.plan_selected);
        const newSlotCount = this.getDeleteActionNextBeneficiaryCount();
        this.beneficiarySlotCountBeforeLastChange =
            projectedSlotCountBeforeChange;
        this.modifiedBeneficiarySlotCount =
            newSlotCount;
        this.pendingModifyPlanOriginalPlan =
            {
                ...this.plan_selected
            };
        const changeBenId = this.beneficiaryDeleteActionRequest
            === 'DEL_SLOT'
            ? null
            : this.beneficiaryDeleteSelected
                ?.ben_id;
        const payload = this.buildModifyPlanActionPayload(this.beneficiaryDeleteActionRequest, newSlotCount, [], changeBenId);
        if (!this.validateModifyPlanSubsPayload(payload)) {
            Swal.fire({
                icon: 'warning',
                title: 'Datos incompletos',
                text: 'No fue posible armar la solicitud. Revisa que exista el plan, el monto y el beneficiario seleccionado cuando corresponda.',
                confirmButtonText: 'Aceptar'
            });
            return;
        }
        this.pendingModifyPlanSubsPayload =
            payload;
        this.closeDeleteBeneficiaryConfirmModal();
        this.openPlanChangeComparisonModal('CHANGE');
    }
    // =========================================================
    // GUARDAR BENEFICIARIO EN CUPO
    // =========================================================
    private async saveBeneficiaryForModifySlot(): Promise<void> {
        if (!this.canAddBeneficiaries(this.plan_selected)) {
            return;
        }
        if (this.savingBeneficiary) {
            return;
        }
        const tieneSlotDisponible = this.editingBeneficiaryIndex !== null
            || this.beneficiariesWorking.length
                < this.modifiedBeneficiarySlotCount;
        if (!tieneSlotDisponible) {
            Swal.fire({
                icon: 'warning',
                title: 'Sin cupos disponibles',
                text: 'No existen cupos disponibles para completar. Para agregar un nuevo cupo al plan se debe realizar una modificación de convenio.',
                confirmButtonText: 'Aceptar'
            });
            return;
        }
        this.refreshBeneficiaryRutValidation();
        if (this.beneficiaryForm.invalid) {
            this.beneficiaryForm
                .markAllAsTouched();
            return;
        }
        const formData = this.beneficiaryForm
            .getRawValue();
        const payload = this.buildAddBeneficiaryPlanSubsMPPayload(formData);
        if (!this.validateAddBeneficiaryPlanSubsMPPayload(payload)) {
            Swal.fire({
                icon: 'warning',
                title: 'Datos incompletos',
                text: 'No fue posible armar la información del beneficiario. Revisa los datos del plan y del formulario.',
                confirmButtonText: 'Aceptar'
            });
            return;
        }
        this.savingBeneficiary =
            true;
        Swal.fire({
            allowOutsideClick: false,
            html: `
        <div style="margin: 40px 0;">
          <i
            class="material-icons"
            style="
              color:#2BABB7;
              font-size:58px;
              margin-bottom:25px
            ">
            schedule
          </i>

          <h1
            style="
              font-family:Mulish;
              font-style:normal;
              font-weight:700;
              font-size:24px;
              line-height:32px;
              text-align:center;
              color:#171994;
            ">
            Agregando beneficiario ...
          </h1>
        </div>
      `,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });
        try {
            const response: any = await this
                .inscripcionConvenioService
                .postAddbeneficiaryPlanSubsMP(payload);
            const beneficiary = {
                use_rut: this.formatRut(formData.use_rut),
                use_name: formData.use_name,
                use_paternal_surname: formData.use_paternal_surname,
                use_maternal_surname: formData.use_maternal_surname,
                use_email: formData.use_email,
                phone_code: formData.phone_code,
                use_phone: formData.use_phone,
                use_movil_phone: this.getBeneficiaryFullPhone(),
                use_birthdate: formData.use_birthdate,
                relationship: formData.relationship,
                ben_id: response?.ben_id
                    || response?.data?.ben_id
                    || `temp_${new Date().getTime()}`,
                ben_main_use_id: this.plan_selected
                    ?.ben_main_use_id,
                ben_use_id: response?.ben_use_id
                    || response?.data?.ben_use_id
                    || null,
                ben_creation_date: new Date()
                    .toLocaleDateString('es-CL')
            };
            if (this.editingBeneficiaryIndex
                !== null) {
                this.beneficiariesWorking[this.editingBeneficiaryIndex] = {
                    ...this.beneficiariesWorking[this.editingBeneficiaryIndex],
                    ...beneficiary
                };
            }
            else {
                this.beneficiariesWorking.push(beneficiary);
            }
            this.updateSelectedPlanBeneficiariesLocal();
            this.originalBeneficiariesModifySnapshot =
                this.cloneBeneficiaries(this.beneficiariesWorking);
            this.beneficiariesBeforeLastChange =
                this.cloneBeneficiaries(this.beneficiariesWorking);
            this.originalBeneficiarySlotCount =
                this.modifiedBeneficiarySlotCount;
            this.beneficiarySlotCountBeforeLastChange =
                this.modifiedBeneficiarySlotCount;
            this.closeBeneficiaryModal();
            Swal.close();
            await Swal.fire({
                allowOutsideClick: false,
                html: ' <i class="material-icons" style="color:#171994;font-size: 58px;margin: 20px 40px 10px;">mood</i> <br><br>' +
                    ' <h1 style="font-family: Mulish; font-style: normal; font-weight: 800;font-size: 28px; line-height: 48px; align-items: center; text-align: center; color: #171994;" >Beneficiario ingresado exitosamente</h1> <br>' +
                    ' <p style="font-family: Mulish; font-style: normal; font-weight: normal; font-size: 18px; line-height: 24px; text-align: center; color: #000000;" ></p><br>',
                confirmButtonText: 'Aceptar',
                showConfirmButton: false,
                timer: 2500
            });
            await this.refreshSelectedPlanAfterBeneficiarySave({
                ...this.plan_selected
            });
        }
        catch (error) {
            console.error('Error postAddbeneficiaryPlanSubsMP:', error);
            Swal.close();
            Swal.fire({
                icon: 'error',
                title: 'No fue posible agregar el beneficiario',
                text: 'Ocurrió un problema al guardar el beneficiario. Intenta nuevamente.',
                confirmButtonText: 'Aceptar'
            });
        }
        finally {
            this.savingBeneficiary =
                false;
        }
    }
    // =========================================================
    // EDITAR BENEFICIARIO
    // =========================================================
    private async editBeneficiaryForModifySlot(): Promise<void> {
        if (!this.canAddBeneficiaries(this.plan_selected)) {
            return;
        }
        if (this.savingBeneficiary) {
            return;
        }
        if (this.editingBeneficiaryIndex === null
            || this.editingBeneficiaryIndex === undefined) {
            return;
        }
        const beneficiaryToEdit = this.beneficiariesWorking[this.editingBeneficiaryIndex];
        if (!beneficiaryToEdit) {
            Swal.fire({
                icon: 'warning',
                title: 'Beneficiario no encontrado',
                text: 'No fue posible identificar el beneficiario a editar.',
                confirmButtonText: 'Aceptar'
            });
            return;
        }
        this.refreshBeneficiaryRutValidation();
        if (this.beneficiaryForm.invalid) {
            this.beneficiaryForm
                .markAllAsTouched();
            return;
        }
        const formData = this.beneficiaryForm
            .getRawValue();
        const payload = this.buildEditBeneficiarySubsPayload(formData, beneficiaryToEdit);
        if (!this.validateEditBeneficiarySubsPayload(payload)) {
            Swal.fire({
                icon: 'warning',
                title: 'Datos incompletos',
                text: 'No fue posible armar la información para editar el beneficiario. Revisa que el plan tenga subs_id, ben_id y los datos del formulario completos.',
                confirmButtonText: 'Aceptar'
            });
            return;
        }
        this.savingBeneficiary =
            true;
        Swal.fire({
            allowOutsideClick: false,
            html: `
        <div style="margin: 40px 0;">
          <i
            class="material-icons"
            style="
              color:#2BABB7;
              font-size:58px;
              margin-bottom:25px
            ">
            schedule
          </i>

          <h1
            style="
              font-family:Mulish;
              font-style:normal;
              font-weight:700;
              font-size:24px;
              line-height:32px;
              text-align:center;
              color:#171994;
            ">
            Actualizando beneficiario ...
          </h1>
        </div>
      `,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });
        const originalPlan = {
            ...this.plan_selected
        };
        try {
            const response: any = await (this.inscripcionConvenioService as any).postEditBeneficiarySubs(payload);
            this.beneficiariesWorking[this.editingBeneficiaryIndex] =
                this.buildBeneficiaryLocalFromForm(formData, beneficiaryToEdit, response);
            this.updateSelectedPlanBeneficiariesLocal();
            this.closeBeneficiaryModal();
            Swal.close();
            await Swal.fire({
                allowOutsideClick: false,
                html: ' <i class="material-icons" style="color:#171994;font-size: 58px;margin: 20px 40px 10px;">mood</i> <br><br>' +
                    ' <h1 style="font-family: Mulish; font-style: normal; font-weight: 800;font-size: 28px; line-height: 48px; align-items: center; text-align: center; color: #171994;" >Beneficiario actualizado exitosamente</h1> <br>' +
                    ' <p style="font-family: Mulish; font-style: normal; font-weight: normal; font-size: 18px; line-height: 24px; text-align: center; color: #000000;" ></p><br>',
                confirmButtonText: 'Aceptar',
                showConfirmButton: false,
                timer: 2500
            });
            await this.refreshSelectedPlanAfterBeneficiarySave(originalPlan);
        }
        catch (error) {
            console.error('Error postEditBeneficiarySubs:', error);
            Swal.close();
            Swal.fire({
                icon: 'error',
                title: 'No fue posible editar el beneficiario',
                text: this.getBackendErrorMessage(error, 'Ocurrió un problema al actualizar el beneficiario. Intenta nuevamente.'),
                confirmButtonText: 'Aceptar'
            });
        }
        finally {
            this.savingBeneficiary =
                false;
        }
    }
    // =========================================================
    // MODALES COMPARACIÓN PLAN
    // =========================================================
    public openPlanChangeComparisonModal(mode: 'CHANGE' | 'FINAL' = 'CHANGE'): void {
        this.planChangeComparisonMode =
            mode;
        this.showPlanChangeFinalConfirmModal =
            false;
        this.showPlanChangeComparisonModal =
            true;
    }
    public closePlanChangeComparisonModal(): void {
        this.showPlanChangeComparisonModal =
            false;
        this.showPlanChangeFinalConfirmModal =
            false;
    }
    public openPlanChangeFinalConfirmModal(): void {
        this.showPlanChangeComparisonModal =
            false;
        this.showPlanChangeFinalConfirmModal =
            true;
    }
    public cancelPlanChangeFinalConfirmModal(): void {
        this.showPlanChangeFinalConfirmModal =
            false;
        this.showPlanChangeComparisonModal =
            true;
    }
    public cancelPlanChangeComparisonModal(): void {
        if (this.planChangeComparisonMode
            === 'CHANGE') {
            this.beneficiariesWorking =
                this.cloneBeneficiaries(this.beneficiariesBeforeLastChange);
            this.modifiedBeneficiarySlotCount =
                this.beneficiarySlotCountBeforeLastChange;
            this.updateSelectedPlanBeneficiariesLocal();
        }
        this.pendingModifyPlanSubsPayload =
            null;
        this.pendingModifyPlanOriginalPlan =
            null;
        this.closePlanChangeComparisonModal();
    }
    public confirmPlanChangeComparisonModal(): void {
        this.openPlanChangeFinalConfirmModal();
    }
    public async confirmPlanChangeFinalConfirmation(): Promise<void> {
        if (this.pendingModifyPlanSubsPayload) {
            await this.confirmPendingModifyPlanSubs();
            return;
        }
        this.updateSelectedPlanBeneficiariesLocal();
        this.closePlanChangeComparisonModal();
        if (this.planChangeComparisonMode
            === 'FINAL') {
            this.updateSelectedPlanSlotLimitLocal(this.modifiedBeneficiarySlotCount);
            this.modifyingConvenio =
                false;
            this.activeDetailTab =
                'configuration';
            this.originalBeneficiariesModifySnapshot =
                this.cloneBeneficiaries(this.beneficiariesWorking);
            this.originalBeneficiarySlotCount =
                this.modifiedBeneficiarySlotCount;
            this.beneficiarySlotCountBeforeLastChange =
                this.modifiedBeneficiarySlotCount;
        }
    }
    private cloneBeneficiaries(list: any[]): any[] {
        return JSON.parse(JSON.stringify(list || []));
    }
    // =========================================================
    // CANCELAR PLAN
    // =========================================================
    public isTrialCycle(plan: any): boolean {
        const paymentPlan = this.getPaymentPlan(plan);
        return Number(paymentPlan?.subs_his_number_cicle) === 0;
    }
    public isCancelPlanConfigurationButtonDisabled(plan: any): boolean {
        return this.hasCancelSubscriptionFutureRequest(plan) && !this.isTrialCycle(plan);
    }
    public getCancelPlanConfigurationButtonText(plan: any): string {
        if (!this.hasCancelSubscriptionFutureRequest(plan)) {
            return 'Dar de baja convenio';
        }
        return this.isTrialCycle(plan)
            ? 'Cancelar baja del convenio'
            : 'Baja de convenio programada';
    }
    public handleCancelPlanConfigurationAction(plan?: any): void {
        if (plan) {
            this.plan_selected = plan;
        }
        const cancelRequest = this.getCancelSubscriptionFutureRequest(this.plan_selected);
        if (cancelRequest) {
            if (this.isTrialCycle(this.plan_selected)) {
                this.requestCancelFutureRequest(cancelRequest);
            }
            return;
        }
        this.requestCancelPlan(this.plan_selected);
    }
    public requestCancelPlan(plan?: any): void {
        if (plan) {
            this.plan_selected =
                plan;
        }
        if (!this.getSubscriptionId(this.plan_selected)) {
            Swal.fire({
                icon: 'warning',
                title: 'No fue posible solicitar la baja',
                text: 'No se encontró la suscripción asociada a este plan.',
                confirmButtonText: 'Aceptar'
            });
            return;
        }
        this.showCancelSubscriptionConfirmModal =
            true;
    }
    /**
     * La fecha efectiva usa ahora el billing_day
     * cuando existe.
     */
    public getCancelSubscriptionEffectiveDate(): string {
        return this.getNextBillingCycleDate(this.plan_selected);
    }
    public getCancelSubscriptionButtonText(): string {
        return this.cancellingSubscription
            ? 'Solicitando...'
            : 'Aceptar baja';
    }
    private getSubscriptionId(plan: any): number {
        const paymentPlan = this.getPaymentPlan(plan);
        return Number(paymentPlan?.subs_id
            || plan?.subs_id
            || 0);
    }
    private buildCancelSubscriptionPayload(): any {
        return {
            subs_id: this.getSubscriptionId(this.plan_selected),
            action_request: 'CANCEL_SUBSCRIPTION'
        };
    }
    private validateCancelSubscriptionPayload(payload: any): boolean {
        return !!(payload?.subs_id
            && payload?.action_request
                === 'CANCEL_SUBSCRIPTION');
    }
    public async confirmCancelSubscription(): Promise<void> {
        if (this.cancellingSubscription) {
            return;
        }
        const payload = this.buildCancelSubscriptionPayload();
        if (!this.validateCancelSubscriptionPayload(payload)) {
            Swal.fire({
                icon: 'warning',
                title: 'Datos incompletos',
                text: 'No fue posible armar la solicitud de baja. Revisa que exista subs_id.',
                confirmButtonText: 'Aceptar'
            });
            return;
        }
        this.cancellingSubscription =
            true;
        Swal.fire({
            allowOutsideClick: false,
            html: `
        <div style="margin: 40px 0;">
          <i
            class="material-icons"
            style="
              color:#2BABB7;
              font-size:58px;
              margin-bottom:25px
            ">
            schedule
          </i>

          <h1
            style="
              font-family:Mulish;
              font-style:normal;
              font-weight:700;
              font-size:24px;
              line-height:32px;
              text-align:center;
              color:#171994;
            ">
            Solicitando baja del convenio ...
          </h1>
        </div>
      `,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });
        const originalPlan = {
            ...this.plan_selected
        };
        try {
            await (this.inscripcionConvenioService as any).postCancelSubscription(payload);
            this.closeCancelSubscriptionConfirmModal();
            Swal.close();
            await Swal.fire({
                allowOutsideClick: false,
                html: ' <i class="material-icons" style="color:#171994;font-size: 58px;margin: 20px 40px 10px;">mood</i> <br><br>' +
                    ' <h1 style="font-family: Mulish; font-style: normal; font-weight: 800;font-size: 28px; line-height: 48px; align-items: center; text-align: center; color: #171994;" >Solicitud de baja ingresada</h1> <br>' +
                    ' <p style="font-family: Mulish; font-style: normal; font-weight: normal; font-size: 18px; line-height: 24px; text-align: center; color: #000000;" >La cancelación del convenio se hará efectiva al finalizar el ciclo de facturación actual</p><br>',
                confirmButtonText: 'Aceptar',
                showConfirmButton: false,
                timer: 2500
            });
            await this.refreshSelectedPlanAfterBeneficiarySave(originalPlan);
        }
        catch (error) {
            console.error('Error postCancelSubscription:', error);
            Swal.close();
            Swal.fire({
                icon: 'error',
                title: 'No fue posible solicitar la baja',
                text: this.getBackendErrorMessage(error, 'Ocurrió un problema al solicitar la baja del convenio. Intenta nuevamente.'),
                confirmButtonText: 'Aceptar'
            });
        }
        finally {
            this.cancellingSubscription =
                false;
        }
    }
    // =========================================================
    // DATOS PLAN
    // =========================================================
    public getPlanLogo(plan: any): string {
        return (plan?.image_plan
            || plan?.cus_url_image_web
            || plan?.cus_url_image_mobile
            || '');
    }
    public getCustomerLogo(plan: any): string {
        return (plan?.cus_url_image_web
            || plan?.cus_url_image_mobile
            || plan?.image_plan
            || '');
    }
    public getCustomerName(plan: any): string {
        return (plan?.cus_name
            || plan?.customer_name
            || plan?.convenio_nombre
            || 'Empresa Demo');
    }
    public getPlanName(plan: any): string {
        return (plan?.cus_ben_name
            || plan?.plan_name
            || 'Plan sin nombre');
    }
    public getPlanDescription(plan: any): string {
        return (plan?.cus_ben_text_consideraciones
            || 'El plan incluye atenciones según tope anual por especialidad. Revisa los topes y condiciones asociados al convenio.');
    }
    public getUserType(plan: any): string {
        if (plan?.is_titular === true) {
            return 'Titular';
        }
        if (plan?.is_titular === false) {
            return 'Beneficiario';
        }
        return Number(plan?.ben_main_use_id) === Number(this.usuario?.use_id)
            ? 'Titular'
            : 'Beneficiario';
    }
    public getPlanType(plan: any): string {
        return plan?.cus_ben_particular
            ? 'Particular'
            : 'Convenio';
    }
    public getStatusLabel(plan: any): string {
        const statusId = Number(plan?.ben_sta_id);
        if (statusId === 60) {
            return 'activo';
        }
        if (statusId === 146) {
            return 'suspendido';
        }
        if (statusId === 147) {
            return 'cancelado';
        }
        return 'Inactivo';
    }
    public getStatusClass(plan: any): string {
        const label = this.normalizeText(this.getStatusLabel(plan));
        if (label.includes('suspendido')) {
            return 'status-suspended';
        }
        if (label.includes('pendiente')) {
            return 'status-pending';
        }
        if (label.includes('inactivo') ||
            label.includes('cancelado') ||
            label.includes('baja')) {
            return 'status-inactive';
        }
        return 'status-active';
    }
    // =========================================================
    // ESPECIALIDADES
    // =========================================================
    public getSpecialties(plan: any): any[] {
        return Array.isArray(plan?.especialidades)
            ? plan.especialidades
            : [];
    }
    public getVisibleSpecialties(plan: any): any[] {
        const specialties = this.getSpecialties(plan);
        return this.showAllSpecialties
            ? specialties
            : specialties.slice(0, this.specialtiesPreviewLimit);
    }
    public hasMoreSpecialties(plan: any): boolean {
        return this
            .getSpecialties(plan)
            .length
            >
                this.specialtiesPreviewLimit;
    }
    public toggleAllSpecialties(): void {
        this.showAllSpecialties =
            !this.showAllSpecialties;
    }
    public getSpecialtyTotal(specialty: any, plan?: any): any {
        const quantity = this.getUserType(plan
            || this.plan_selected) === 'Titular'
            ? specialty?.cus_ben_qty_con_titular
            : specialty?.cus_ben_qty_con_beneficiaries;
        if (quantity === null
            || quantity === undefined
            || quantity === '') {
            return 'Ilimitadas';
        }
        return Number(quantity) || 0;
    }
    public getSpecialtyUsed(specialty: any): number {
        return Number(specialty?.consultas_usadas) || 0;
    }
    public getSpecialtyAvailable(specialty: any, plan?: any): any {
        const total = this.getSpecialtyTotal(specialty, plan);
        if (total === 'Ilimitadas') {
            return 'Ilimitadas';
        }
        return Math.max(Number(total)
            -
                this.getSpecialtyUsed(specialty), 0);
    }
    public getConsultasText(specialty: any): string {
        const quantity = specialty?.cus_ben_qty_con_titular;
        if (quantity === null
            || quantity === undefined
            || quantity === '') {
            return 'Ilimitadas';
        }
        return `${quantity}`;
    }
    public getUsedConsultasText(specialty: any): string {
        const used = specialty?.consultas_usadas
            || 0;
        const total = specialty?.cus_ben_qty_con_titular;
        if (total === null
            || total === undefined
            || total === '') {
            return `${used} de ilimitadas`;
        }
        return `${used} de ${total}`;
    }
    // =========================================================
    // BENEFICIARIOS PLAN
    // =========================================================
    public getAssociatedBeneficiaries(plan: any): any[] {
        const beneficiaries = Array.isArray(plan?.beneficiarios)
            ? plan.beneficiarios
            : [];
        const unique: any[] = [];
        const seen: any = {};
        beneficiaries.forEach((beneficiary: any) => {
            const isHolder = Number(beneficiary?.ben_use_id)
                ===
                    Number(beneficiary?.ben_main_use_id
                        || plan?.ben_main_use_id);
            if (isHolder) {
                return;
            }
            const key = `${beneficiary?.ben_use_id || ''}-${beneficiary?.use_rut || ''}`;
            if (!seen[key]) {
                seen[key] = true;
                unique.push(beneficiary);
            }
        });
        return unique;
    }
    public getPendingBeneficiariesWithoutAccount(plan: any): any[] {
        return Array.isArray(plan?.beneficiarios_sin_cuenta)
            ? plan.beneficiarios_sin_cuenta
            : [];
    }
    // =========================================================
    // SOLICITUDES FUTURAS
    // =========================================================
    public getFutureChangeRequests(plan: any): any[] {
        const paymentPlans = Array.isArray(plan?.planPagos)
            ? plan.planPagos
            : [];
        const requests: any[] = [];
        paymentPlans.forEach((paymentPlan: any) => {
            const listRequest = Array.isArray(paymentPlan?.listRequest)
                ? paymentPlan.listRequest
                : [];
            listRequest.forEach((request: any) => {
                if (!this.isFutureChangeRequest(request)) {
                    return;
                }
                requests.push({
                    ...request,
                    subs_id: paymentPlan?.subs_id,
                    subs_facturation_date: paymentPlan?.subs_facturation_date,
                    sub_pay_id: paymentPlan?.sub_pay_id
                });
            });
        });
        return requests;
    }
    public hasFutureChangeRequests(plan: any): boolean {
        return this
            .getFutureChangeRequests(plan)
            .length > 0;
    }
    public getVisibleFutureChangeRequests(plan: any): any[] {
        const requests = this.getFutureChangeRequests(plan);
        const cancelSubscriptionRequest = requests.find((request: any) => {
            return this.getFutureRequestAction(request) === 'CANCEL_SUBSCRIPTION';
        });
        return cancelSubscriptionRequest
            ? [
                cancelSubscriptionRequest
            ]
            : requests;
    }
    public hasVisibleFutureChangeRequests(plan: any): boolean {
        return this
            .getVisibleFutureChangeRequests(plan)
            .length > 0;
    }
    public getVisibleFutureChangeRequestsCount(plan: any): number {
        return this
            .getVisibleFutureChangeRequests(plan)
            .length;
    }
    public hasCancelSubscriptionFutureRequest(plan: any): boolean {
        return this
            .getFutureChangeRequests(plan)
            .some((request: any) => {
            return this.getFutureRequestAction(request)
                === 'CANCEL_SUBSCRIPTION';
        });
    }
    private getCancelSubscriptionFutureRequest(plan: any): any {
        return this
            .getFutureChangeRequests(plan)
            .find((request: any) => {
            return this.getFutureRequestAction(request)
                === 'CANCEL_SUBSCRIPTION';
        })
            || null;
    }
    private getDeleteSlotFutureRequests(plan: any): any[] {
        return this
            .getFutureChangeRequests(plan)
            .filter((request: any) => {
            return this.getFutureRequestAction(request)
                === 'DEL_SLOT';
        });
    }
    private getVisibleBeneficiariesForCurrentTables(plan: any): any[] {
        const useWorkingList = this.plan_selected
            &&
                (plan
                    === this.plan_selected
                    || plan?.ben_policy_number
                        === this.plan_selected?.ben_policy_number
                    || Number(plan?.cus_ben_id
                        || 0)
                        ===
                            Number(this.plan_selected?.cus_ben_id
                                || 0))
            && this.beneficiariesWorking.length > 0;
        return useWorkingList
            ? this.beneficiariesWorking
            : this.getAssociatedBeneficiaries(plan);
    }
    private getVisibleSlotLimitForCurrentTables(plan: any, customSlotCount?: number): number {
        const baseLimit = customSlotCount !== undefined
            && customSlotCount !== null
            ? Number(customSlotCount
                || 0)
            : this.getBeneficiaryLimit(plan);
        return Math.max(baseLimit, 0);
    }
    public isCancelSubscriptionFutureRequest(request: any): boolean {
        return this.getFutureRequestAction(request)
            === 'CANCEL_SUBSCRIPTION';
    }
    public getFutureChangeRequestsCount(plan: any): number {
        return this
            .getFutureChangeRequests(plan)
            .length;
    }
    private isFutureChangeRequest(request: any): boolean {
        const status = request?.change_status;
        if (status === false
            || status === 0) {
            return true;
        }
        if (typeof status === 'string') {
            const normalizedStatus = status
                .trim()
                .toLowerCase();
            return (normalizedStatus === 'false'
                || normalizedStatus === '0');
        }
        return false;
    }
    private buildFutureChangeRequestRow(request: any, index: number): any {
        return {
            isPending: true,
            isFutureRequest: true,
            data: request,
            realIndex: null,
            requestIndex: index
        };
    }
    public getFutureRequestTypeLabel(request: any): string {
        const action = this.getFutureRequestAction(request);
        if (action === 'ADD_SLOT_BEN') {
            return 'Agregar cupo con beneficiario';
        }
        if (action === 'ADD_SLOT') {
            return 'Agregar cupo disponible';
        }
        if (action === 'EDIT_SLOT') {
            return 'Completar cupo disponible';
        }
        if (action === 'DEL_SLOT') {
            return 'Eliminar cupo disponible';
        }
        if (action === 'DEL_SLOT_BEN') {
            return 'Eliminar cupo y beneficiario';
        }
        if (action === 'DEL_BEN') {
            return 'Vaciar datos del beneficiario';
        }
        if (action === 'CANCEL_SUBSCRIPTION') {
            return 'Baja de convenio';
        }
        return 'Solicitud de cambio';
    }
    public getFutureRequestAction(request: any): string {
        return (request?.change_action
            || request?.action_request
            || '')
            .toString()
            .toUpperCase();
    }
    public getFutureRequestCode(request: any): string {
        const action = this.getFutureRequestAction(request);
        return action
            || 'REQUEST';
    }
    public getFutureRequestActionClass(request: any): string {
        const action = this.getFutureRequestAction(request);
        if (action === 'ADD_SLOT'
            || action === 'ADD_SLOT_BEN'
            || action === 'EDIT_SLOT') {
            return 'request-add';
        }
        if (action === 'DEL_SLOT'
            || action === 'DEL_SLOT_BEN'
            || action === 'DEL_BEN'
            || action === 'CANCEL_SUBSCRIPTION') {
            return 'request-delete';
        }
        return 'request-neutral';
    }
    private findBeneficiaryByBenId(plan: any, benId: any): any {
        const id = Number(benId
            || 0);
        if (!id) {
            return null;
        }
        const beneficiaries = this.getAssociatedBeneficiaries(plan);
        return beneficiaries.find((beneficiary: any) => Number(beneficiary?.ben_id
            || 0)
            === id)
            || null;
    }
    public getFutureRequestTarget(request: any): string {
        const action = this.getFutureRequestAction(request);
        if (action === 'ADD_SLOT') {
            return 'Modificación de convenio';
        }
        if (action === 'DEL_SLOT') {
            return 'Cupo disponible';
        }
        if (action === 'CANCEL_SUBSCRIPTION') {
            return this.getPlanName(this.plan_selected);
        }
        const beneficiaryById = this.findBeneficiaryByBenId(this.plan_selected, this.getRequestChangeBenId(request));
        if (beneficiaryById) {
            return `${this.getFullName(beneficiaryById)} · ${beneficiaryById?.use_rut || 'Sin RUT'}`;
        }
        const requestName = [
            request?.change_name,
            request?.change_paternal_surname,
            request?.change_maternal_surname
        ]
            .filter((item: any) => !!item)
            .join(' ')
            .trim();
        if (requestName
            || request?.change_rut_ben) {
            return `${requestName || 'Beneficiario'}${request?.change_rut_ben
                ? ' · ' + request.change_rut_ben
                : ''}`;
        }
        if (action === 'EDIT_SLOT') {
            return 'Cupo disponible existente';
        }
        return 'Plan completo';
    }
    public getFutureRequestResultLabel(request: any): string {
        const action = this.getFutureRequestAction(request);
        if (action === 'ADD_SLOT') {
            return '1 cupo más';
        }
        if (action === 'ADD_SLOT_BEN') {
            return '1 cupo más con beneficiario activo';
        }
        if (action === 'EDIT_SLOT') {
            return 'Cupo disponible quedará con datos';
        }
        if (action === 'DEL_SLOT') {
            return '1 cupo menos';
        }
        if (action === 'DEL_SLOT_BEN') {
            return '1 cupo menos y beneficiario desactivado';
        }
        if (action === 'DEL_BEN') {
            return 'Cupo queda disponible';
        }
        if (action === 'CANCEL_SUBSCRIPTION') {
            return 'Convenio finaliza al término del ciclo';
        }
        return 'Cambio programado';
    }
    public getFutureRequestImpactLabel(request: any): string {
        const action = this.getFutureRequestAction(request);
        if (action === 'CANCEL_SUBSCRIPTION') {
            return 'Detiene cobro futuro';
        }
        const delta = this.getFutureRequestSlotDelta(request);
        if (delta > 0) {
            return 'Sube tarifa';
        }
        if (delta < 0) {
            return 'Baja tarifa';
        }
        return 'Sin cambio de tarifa';
    }
    public getCancelRequestButtonText(request: any): string {
        return 'Cancelar solicitud';
    }
    // =========================================================
    // FILAS BENEFICIARIOS
    // =========================================================
    public getModifyRowName(row: any): string {
        if (row?.isPending) {
            return 'Cupo disponible';
        }
        return this.getBeneficiaryRowName(row);
    }
    public getBeneficiaryCurrentStatusText(row: any): string {
        if (row?.futureDeleteRequest) {
            return 'Próximo a eliminación';
        }
        if (row?.isPending) {
            return 'Cupo disponible';
        }
        return this.getBeneficiaryActiveStatusText(row?.data);
    }
    public getBeneficiaryCurrentStatusClass(row: any): string {
        if (row?.futureDeleteRequest) {
            return 'status-delete-pending';
        }
        if (row?.isPending) {
            return 'status-empty-slot';
        }
        return this.getBeneficiaryActiveStatusClass(row?.data);
    }
    public getModifyRowProgrammedChangeText(row: any): string {
        if (!row?.futureDeleteRequest) {
            return 'Sin cambios';
        }
        const action = this.getFutureRequestAction(row.futureDeleteRequest);
        if (action === 'CANCEL_SUBSCRIPTION') {
            return 'Solicitud de baja';
        }
        if (action === 'DEL_BEN') {
            return 'Borrar datos beneficiario';
        }
        if (action === 'DEL_SLOT_BEN') {
            return 'Eliminar cupo y beneficiario';
        }
        if (action === 'DEL_SLOT') {
            return 'Eliminar cupo disponible';
        }
        return this.getFutureRequestTypeLabel(row.futureDeleteRequest);
    }
    public getModifyRowFutureRequestClass(row: any): string {
        if (!row?.futureDeleteRequest) {
            return 'request-no-change';
        }
        return 'request-delete';
    }
    // =========================================================
    // PRÓXIMO CICLO DE FACTURACIÓN
    // =========================================================
    /**
     * Ahora también respeta billing_day.
     *
     * Evita que otra sección de la interfaz
     * muestre 09/09 cuando Mercado Pago cobra el día 24.
     */
    public getNextBillingCycleDate(plan: any): string {
        if (!this.hasPlanPayments(plan)) {
            return this.formatDateToDisplay(plan?.cus_dat_to_date);
        }
        const realRows = this.buildPaidPaymentHistory(plan);
        const nextBillingDate = this.getNextProjectedBillingDate(plan, realRows);
        if (nextBillingDate) {
            return this.formatDateToDisplay(nextBillingDate);
        }
        /*
         * Último fallback.
         */
        const paymentPlan = this.getPaymentPlan(plan);
        return this.formatDateToDisplay(paymentPlan
            ?.sub_pay_provider_response
            ?.next_payment_date
            || paymentPlan
                ?.subs_facturation_date);
    }
    // =========================================================
    // PLAN CON PAGOS
    // =========================================================
    public hasPlanPayments(plan: any): boolean {
        return Array.isArray(plan?.planPagos)
            &&
                plan.planPagos.length > 0;
    }
    // =========================================================
    // RENOVACIÓN ANUAL
    // =========================================================
    public getPlanAnnualRenewalDate(plan: any): string {
        if (!this.hasPlanPayments(plan)) {
            return this.formatDateToDisplay(plan?.cus_dat_to_date);
        }
        const paymentPlan = this.getPaymentPlan(plan);
        const providerResponse = paymentPlan?.sub_pay_provider_response
            || {};
        /*
         * Para mantener compatibilidad con la lógica
         * existente del proyecto, la renovación anual
         * continúa utilizando la fecha interna si existe.
         *
         * Esto es independiente de la proyección
         * mensual del historial.
         */
        const firstRegularBillingValue = paymentPlan?.subs_facturation_date
            || providerResponse?.next_payment_date;
        const firstRegularBillingDate = this.parsePlanDate(firstRegularBillingValue);
        if (firstRegularBillingDate) {
            return this.formatDateToDisplay(this.addMonthsPreservingDay(firstRegularBillingDate, 12));
        }
        const startDate = this.parsePlanDate(providerResponse
            ?.auto_recurring
            ?.start_date
            || paymentPlan
                ?.subs_his_date_payment
            || plan
                ?.cus_dat_from_date);
        if (!startDate) {
            return this.formatDateToDisplay(plan?.cus_dat_to_date);
        }
        const billingDay = Number(providerResponse
            ?.auto_recurring
            ?.billing_day
            || startDate.getDate());
        const firstBillingDate = this.buildNextBillingDate(startDate, billingDay);
        return this.formatDateToDisplay(this.addMonthsPreservingDay(firstBillingDate, 12));
    }
    // =========================================================
    // FECHAS
    // =========================================================
    private parsePlanDate(value: any): Date | null {
        if (!value) {
            return null;
        }
        if (value instanceof Date) {
            if (isNaN(value.getTime())) {
                return null;
            }
            return new Date(value.getFullYear(), value.getMonth(), value.getDate());
        }
        const rawValue = value
            .toString()
            .trim();
        // YYYY-MM-DD
        let match = rawValue.match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (match) {
            const year = Number(match[1]);
            const month = Number(match[2]);
            const day = Number(match[3]);
            return new Date(year, month - 1, day);
        }
        // DD/MM/YYYY
        match =
            rawValue.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
        if (match) {
            const day = Number(match[1]);
            const month = Number(match[2]);
            const year = Number(match[3]);
            return new Date(year, month - 1, day);
        }
        const parsedDate = new Date(rawValue);
        if (isNaN(parsedDate.getTime())) {
            return null;
        }
        return new Date(parsedDate.getFullYear(), parsedDate.getMonth(), parsedDate.getDate());
    }
    private addMonthsPreservingDay(sourceDate: Date, monthsToAdd: number): Date {
        const sourceDay = sourceDate.getDate();
        const targetMonth = new Date(sourceDate.getFullYear(), sourceDate.getMonth()
            + monthsToAdd, 1);
        const lastDayOfTargetMonth = new Date(targetMonth.getFullYear(), targetMonth.getMonth() + 1, 0)
            .getDate();
        targetMonth.setDate(Math.min(sourceDay, lastDayOfTargetMonth));
        return targetMonth;
    }
    private buildNextBillingDate(startDate: Date, billingDay: number): Date {
        const normalizedBillingDay = Math.min(Math.max(Number(billingDay) || 1, 1), 31);
        let candidate = this.buildDateWithBillingDay(startDate.getFullYear(), startDate.getMonth(), normalizedBillingDay);
        const normalizedStartDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
        if (candidate <= normalizedStartDate) {
            candidate =
                this.buildDateWithBillingDay(startDate.getFullYear(), startDate.getMonth() + 1, normalizedBillingDay);
        }
        return candidate;
    }
    /**
     * Construye una fecha utilizando el día fijo
     * de facturación.
     *
     * Ejemplo:
     *
     * billing_day = 31
     *
     * enero      -> 31
     * febrero    -> 28/29
     * marzo      -> 31
     */
    private buildDateWithBillingDay(year: number, monthIndex: number, billingDay: number): Date {
        const firstDayOfTargetMonth = new Date(year, monthIndex, 1);
        const normalizedYear = firstDayOfTargetMonth
            .getFullYear();
        const normalizedMonth = firstDayOfTargetMonth
            .getMonth();
        const lastDayOfMonth = new Date(normalizedYear, normalizedMonth + 1, 0)
            .getDate();
        return new Date(normalizedYear, normalizedMonth, Math.min(Math.max(Number(billingDay) || 1, 1), lastDayOfMonth));
    }
    // =========================================================
    // FUTURE REQUEST BENEFICIARIO
    // =========================================================
    private getRequestChangeBenId(request: any): number {
        return Number(request?.change_ben_id
            || 0);
    }
    private isDeleteBeneficiaryFutureRequest(request: any): boolean {
        const action = (request?.change_action
            || request?.action_request
            || '')
            .toString()
            .toUpperCase();
        return (action === 'DEL_SLOT_BEN'
            || action === 'DEL_BEN');
    }
    private getFutureDeleteRequestForBeneficiary(plan: any, beneficiary: any): any {
        const benId = Number(beneficiary?.ben_id
            || 0);
        if (!benId) {
            return null;
        }
        return this
            .getFutureChangeRequests(plan)
            .find((request: any) => {
            return (this.isDeleteBeneficiaryFutureRequest(request)
                &&
                    this.getRequestChangeBenId(request) === benId);
        })
            || null;
    }
    private shouldShowFutureRequestAsOwnRow(request: any, activeBeneficiaries: any[]): boolean {
        if (!this.isDeleteBeneficiaryFutureRequest(request)) {
            return true;
        }
        const changeBenId = this.getRequestChangeBenId(request);
        if (!changeBenId) {
            return true;
        }
        return !activeBeneficiaries.some((beneficiary: any) => Number(beneficiary?.ben_id
            || 0)
            === changeBenId);
    }
    // =========================================================
    // DATOS FILA BENEFICIARIO
    // =========================================================
    public getBeneficiaryRowName(row: any): string {
        if (row?.isFutureRequest) {
            const action = (row?.data?.change_action
                || row?.data?.action_request
                || '')
                .toString()
                .toUpperCase();
            if (action === 'ADD_SLOT') {
                return 'Nuevo cupo solicitado';
            }
            if (action === 'DEL_SLOT') {
                return 'Cupo programado para eliminar';
            }
            if (action === 'DEL_SLOT_BEN'
                || action === 'DEL_BEN') {
                return 'Beneficiario programado para eliminación';
            }
            return [
                row?.data?.change_name,
                row?.data?.change_paternal_surname,
                row?.data?.change_maternal_surname
            ]
                .filter((item: any) => !!item)
                .join(' ')
                .trim()
                || 'Nuevo beneficiario solicitado';
        }
        if (row?.isPending) {
            return '—';
        }
        return this.getFullName(row?.data);
    }
    public getBeneficiaryRowRut(row: any): string {
        if (row?.isFutureRequest) {
            return row?.data?.change_rut_ben
                || '—';
        }
        if (row?.isPending) {
            return '—';
        }
        return row?.data?.use_rut
            || '—';
    }
    public getBeneficiaryRowEmail(row: any): string {
        if (row?.isFutureRequest) {
            return row?.data?.change_email
                || '—';
        }
        if (row?.isPending) {
            return '—';
        }
        return row?.data?.use_email
            || '—';
    }
    public getBeneficiaryRowDate(row: any): string {
        if (row?.isFutureRequest) {
            return `Próximo ciclo: ${this.formatDateToDisplay(row?.data?.subs_facturation_date)}`;
        }
        if (row?.isPending) {
            return '—';
        }
        return this.getDate(row?.data?.ben_creation_date);
    }
    public getBeneficiaryActiveStatusText(beneficiary: any): string {
        const statusId = Number(beneficiary?.ben_sta_id
            || 0);
        if (!statusId
            || statusId === 60) {
            return 'Activo';
        }
        return 'Inactivo';
    }
    public getBeneficiaryActiveStatusClass(beneficiary: any): string {
        const statusId = Number(beneficiary?.ben_sta_id
            || 0);
        if (!statusId
            || statusId === 60) {
            return 'status-active';
        }
        return 'status-inactive';
    }
    public getBeneficiaryRowStatusText(row: any): string {
        if (row?.futureDeleteRequest) {
            return 'Próximo a eliminación';
        }
        if (row?.isFutureRequest) {
            return 'Próximo ciclo';
        }
        if (row?.isPending) {
            return 'Cupo disponible';
        }
        return this.getBeneficiaryActiveStatusText(row?.data);
    }
    public getBeneficiaryRowStatusClass(row: any): string {
        if (row?.futureDeleteRequest) {
            return 'status-delete-pending';
        }
        if (row?.isFutureRequest) {
            return 'status-future';
        }
        if (row?.isPending) {
            return 'status-empty-slot';
        }
        return this.getBeneficiaryActiveStatusClass(row?.data);
    }
    // =========================================================
    // CONTADORES BENEFICIARIOS
    // =========================================================
    public getBeneficiariesCount(plan: any): number {
        return this
            .getAssociatedBeneficiaries(plan)
            .length;
    }
    public hasAssociatedBeneficiaries(plan: any): boolean {
        return this.getBeneficiariesCount(plan) > 0;
    }
    public hasBeneficiariesOrAvailableSlots(plan: any): boolean {
        return this
            .getBeneficiaryRows(plan)
            .length > 0;
    }
    public goToPlanConfiguration(): void {
        if (!this.hasPlanPayments(this.plan_selected)) {
            return;
        }
        this.setActiveDetailTab('configuration');
    }
    private getCurrentBeneficiariesCountForModify(): number {
        return this
            .getVisibleBeneficiariesForCurrentTables(this.plan_selected)
            .length;
    }
    private getAvailableSlotsToFillInModify(): number {
        if (this.hasCancelSubscriptionFutureRequest(this.plan_selected)) {
            return 0;
        }
        return this
            .getBeneficiaryRows(this.plan_selected)
            .filter((row: any) => {
            return (row?.isPending
                && !row?.futureDeleteRequest);
        })
            .length;
    }
    private hasAvailableSlotsToFillInModify(): boolean {
        return this.getAvailableSlotsToFillInModify()
            > 0;
    }
    // =========================================================
    // PAYMENT PLAN
    // =========================================================
    public getPaymentPlan(plan: any): any {
        if (Array.isArray(plan?.planPagos)
            && plan.planPagos.length > 0) {
            return plan.planPagos[0];
        }
        return {};
    }
    private getPaymentProvider(plan: any = this.plan_selected): string {
        return this.cleanString(this.getPaymentPlan(plan)?.sub_pay_provider).toUpperCase();
    }
    private isSupportedModificationProvider(provider: any): boolean {
        const normalizedProvider = this.cleanString(provider).toUpperCase();
        return normalizedProvider === 'MERCADO_PAGO'
            || normalizedProvider === 'VIRTUAL_POS';
    }
    private async postModifyPlanByProvider(payload: any): Promise<any> {
        const provider = this.cleanString(payload?.sub_pay_provider
            || this.getPaymentProvider(this.plan_selected)).toUpperCase();
        if (!this.isSupportedModificationProvider(provider)) {
            throw new Error(`Proveedor de pago no soportado para modificar el plan: ${provider || 'SIN_PROVEEDOR'}`);
        }
        const requestPayload = {
            ...payload,
            sub_pay_provider: provider
        };
        if (provider === 'MERCADO_PAGO') {
            return (this.inscripcionConvenioService as any).postModifyPlanSubsMP(requestPayload);
        }
        return (this.inscripcionConvenioService as any).postModifyPlanSubsVP(requestPayload);
    }
    // =========================================================
    // CUPOS
    // =========================================================
    public getBeneficiaryLimit(plan: any): number {
        if (!this.isSubscriptionPlan(plan)) {
            return 0;
        }
        const paymentPlan = this.getPaymentPlan(plan);
        const candidates = [
            paymentPlan?.sub_cant_beneficiarios,
            plan?.sub_cant_beneficiarios,
            plan?.cus_ben_qty_beneficiaries
        ];
        for (const value of candidates) {
            if (value === null
                || value === undefined
                || value === '') {
                continue;
            }
            const numericValue = Number(value);
            if (Number.isFinite(numericValue)) {
                return Math.max(numericValue, 0);
            }
        }
        return 0;
    }
    public getBeneficiariesSummary(plan: any): string {
        const count = this.getBeneficiariesCount(plan);
        if (!this.isSubscriptionPlan(plan)) {
            return `${count}`;
        }
        const limit = this.getBeneficiaryLimit(plan);
        if (!limit) {
            return `${count}`;
        }
        return `${count} de ${limit}`;
    }
    public getPendingBeneficiaries(plan: any): number {
        if (!this.canAddBeneficiaries(plan)
            || this.hasCancelSubscriptionFutureRequest(plan)) {
            return 0;
        }
        return this
            .getBeneficiaryRows(plan)
            .filter((row: any) => {
            return (row?.isPending
                && !row?.futureDeleteRequest);
        })
            .length;
    }
    public hasPendingBeneficiaries(plan: any): boolean {
        return (this.canAddBeneficiaries(plan)
            &&
                this.getPendingBeneficiaries(plan) > 0);
    }
    public getBeneficiaryRows(plan: any): any[] {
        const limit = this.getVisibleSlotLimitForCurrentTables(plan);
        const activeBeneficiaries = this.getVisibleBeneficiariesForCurrentTables(plan);
        const cancelSubscriptionRequest = this.getCancelSubscriptionFutureRequest(plan);
        const deleteSlotRequests = this.getDeleteSlotFutureRequests(plan);
        let deleteSlotRequestIndex = 0;
        const rows: any[] = activeBeneficiaries.map((beneficiary: any, index: number) => ({
            isPending: false,
            isFutureRequest: false,
            futureDeleteRequest: cancelSubscriptionRequest
                || this.getFutureDeleteRequestForBeneficiary(plan, beneficiary),
            data: beneficiary,
            realIndex: index
        }));
        if (this.canAddBeneficiaries(plan)) {
            const pendingWithoutAccount = this.getPendingBeneficiariesWithoutAccount(plan);
            const maxRows = Math.max(limit > 0
                ? limit
                : rows.length
                    + pendingWithoutAccount.length, rows.length);
            pendingWithoutAccount.forEach((beneficiary: any) => {
                if (rows.length >= maxRows) {
                    return;
                }
                const requestForRow = cancelSubscriptionRequest
                    || this.getFutureDeleteRequestForBeneficiary(plan, beneficiary)
                    || deleteSlotRequests[deleteSlotRequestIndex]
                    || null;
                if (!cancelSubscriptionRequest
                    && requestForRow
                    && this.getFutureRequestAction(requestForRow) === 'DEL_SLOT') {
                    deleteSlotRequestIndex++;
                }
                rows.push({
                    isPending: true,
                    isFutureRequest: false,
                    futureDeleteRequest: requestForRow,
                    data: beneficiary,
                    realIndex: null
                });
            });
            while (rows.length < maxRows) {
                const requestForRow = cancelSubscriptionRequest
                    || deleteSlotRequests[deleteSlotRequestIndex]
                    || null;
                if (!cancelSubscriptionRequest
                    && requestForRow
                    && this.getFutureRequestAction(requestForRow) === 'DEL_SLOT') {
                    deleteSlotRequestIndex++;
                }
                rows.push({
                    isPending: true,
                    isFutureRequest: false,
                    futureDeleteRequest: requestForRow,
                    data: null,
                    realIndex: null
                });
            }
        }
        return rows;
    }
    // =========================================================
    // DATOS PERSONA
    // =========================================================
    public getFullName(person: any): string {
        return [
            person?.use_name,
            person?.use_paternal_surname,
            person?.use_maternal_surname
        ]
            .filter((item: any) => !!item)
            .join(' ')
            .trim()
            || 'Sin nombre';
    }
    public getHolderName(plan: any): string {
        return this.getFullName(plan);
    }
    public getHolderRut(plan: any): string {
        return plan?.use_rut
            || '—';
    }
    public getDate(value: any): string {
        return value
            || '—';
    }
    // =========================================================
    // FORMAT FECHA
    // =========================================================
    public formatDateToDisplay(value: any): string {
        if (!value) {
            return '—';
        }
        if (typeof value === 'string'
            && value.includes('/')
            && value.length <= 10) {
            return value;
        }
        /*
         * Utilizamos parsePlanDate primero
         * para evitar desfases por timezone.
         */
        const date = this.parsePlanDate(value);
        if (!date) {
            return value;
        }
        const day = String(date.getDate())
            .padStart(2, '0');
        const month = String(date.getMonth() + 1)
            .padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    }
    // =========================================================
    // PRECIOS
    // =========================================================
    public formatPrice(value: any): string {
        const numberValue = Number(value);
        if (value === null
            || value === undefined
            || value === ''
            || isNaN(numberValue)) {
            return '—';
        }
        return numberValue.toLocaleString('es-CL', {
            style: 'currency',
            currency: 'CLP',
            maximumFractionDigits: 0
        });
    }
    public getPriceNumber(value: any): number | null {
        const numberValue = Number(value);
        if (value === null
            || value === undefined
            || value === ''
            || isNaN(numberValue)) {
            return null;
        }
        return numberValue;
    }
    private getTarifaTitular(plan: any): number | null {
        return this.getPriceNumber(plan?.tarifas?.priceTitular
            || plan?.cus_ben_price_titular
            || plan?.price_titular
            || plan?.precio_titular);
    }
    private getTarifaCarga1(plan: any): number | null {
        return this.getPriceNumber(plan?.tarifas?.priceCarga1
            || plan?.cus_ben_price_carga1
            || plan?.price_carga1
            || plan?.precio_carga1);
    }
    private getTarifaCarga2(plan: any): number | null {
        return this.getPriceNumber(plan?.tarifas?.priceCarga2
            || plan?.cus_ben_price_carga2
            || plan?.price_carga2
            || plan?.precio_carga2);
    }
    public getPriceTitular(plan: any): string {
        return this.formatPrice(this.getTarifaTitular(plan));
    }
    public getPriceBeneficiaries(plan: any): string {
        return this.formatPrice(this.getTarifaCarga1(plan));
    }
    public getRemainingBeneficiariesPrice(plan: any): string {
        return this.formatPrice(this.getTarifaCarga2(plan));
    }
    public getPlanPriceDetailItems(plan: any): Array<{
        label: string;
        amount: number;
        isHolder: boolean;
    }> {
        const items: Array<{
            label: string;
            amount: number;
            isHolder: boolean;
        }> = [];
        items.push({
            label: 'Titular',
            amount: this.getTarifaTitular(plan) || 0,
            isHolder: true
        });
        const beneficiaryCount = this.getBeneficiaryLimit(plan);
        for (let index = 0; index < beneficiaryCount; index++) {
            items.push({
                label: `Beneficiario ${index + 1}`,
                amount: index === 0
                    ? this.getTarifaCarga1(plan) || 0
                    : this.getTarifaCarga2(plan) || 0,
                isHolder: false
            });
        }
        return items;
    }
    public getPlanPriceDetailSummary(plan: any): string {
        const beneficiaryCount = this.getBeneficiaryLimit(plan);
        const beneficiaryLabel = beneficiaryCount === 1
            ? 'beneficiario'
            : 'beneficiarios';
        return `1 titular + ${beneficiaryCount} ${beneficiaryLabel}`;
    }
    public getMonthlyPrice(plan: any): string {
        const titular = this.getTarifaTitular(plan) || 0;
        const carga1 = this.getTarifaCarga1(plan) || 0;
        const carga2 = this.getTarifaCarga2(plan) || 0;
        const cantidadBeneficiarios = this.getBeneficiaryLimit(plan);
        if (titular > 0) {
            let total = titular;
            if (cantidadBeneficiarios >= 1) {
                total +=
                    carga1;
            }
            if (cantidadBeneficiarios > 1) {
                total +=
                    (cantidadBeneficiarios - 1)
                        *
                            carga2;
            }
            return this.formatPrice(total);
        }
        const paymentPlan = this.getPaymentPlan(plan);
        return this.formatPrice(paymentPlan?.sub_pay_total_amount
            || plan?.sub_pay_total_amount
            || plan?.cus_ben_total_price
            || plan?.price_total
            || plan?.precio_total);
    }
    // =========================================================
    // MODIFICAR BENEFICIARIOS
    // =========================================================
    public getModifyBeneficiaryRows(plan: any): any[] {
        return this.getBeneficiaryRows(plan);
    }
    public getCurrentConditionBeneficiaryCount(): number {
        return this.normalizeBeneficiarySlotCount(this.getCurrentActiveBeneficiarySlots(this.plan_selected), this.getBeneficiaryLimit(this.plan_selected));
    }
    public getNewConditionBeneficiaryCount(): number {
        return this.normalizeBeneficiarySlotCount(this.modifiedBeneficiarySlotCount, this.getNextCycleBeneficiaryCount(this.plan_selected));
    }
    private normalizeBeneficiarySlotCount(value: any, fallback: number): number {
        if (value === null
            || value === undefined
            || value === ''
            || isNaN(Number(value))) {
            return Math.max(Number(fallback) || 0, 0);
        }
        return Math.max(Number(value), 0);
    }
    // =========================================================
    // CALCULAR MONTO PARA PLAN ESPECÍFICO
    // =========================================================
    private getPlanMonthlyAmountByBeneficiaryCountForPlan(plan: any, quantityBeneficiaries: number): number {
        const titular = this.getTarifaTitular(plan) || 0;
        const carga1 = this.getTarifaCarga1(plan) || 0;
        const carga2 = this.getTarifaCarga2(plan) || 0;
        const quantity = Math.max(Number(quantityBeneficiaries) || 0, 0);
        let total = titular;
        if (quantity >= 1) {
            total +=
                carga1;
        }
        if (quantity > 1) {
            total +=
                (quantity - 1)
                    *
                        carga2;
        }
        return total;
    }
    public getPlanMonthlyAmountByBeneficiaryCount(quantityBeneficiaries: number): number {
        return this
            .getPlanMonthlyAmountByBeneficiaryCountForPlan(this.plan_selected, quantityBeneficiaries);
    }
    public getPlanConditionItems(quantityBeneficiaries: number): any[] {
        const items: any[] = [];
        items.push({
            label: 'Titular',
            amount: this.getTarifaTitular(this.plan_selected) || 0,
            icon: 'fi fi-rr-user'
        });
        for (let index = 0; index < quantityBeneficiaries; index++) {
            items.push({
                label: index === 0
                    ? 'Beneficiario 1'
                    : `Beneficiario ${index + 1}`,
                amount: index === 0
                    ? this.getTarifaCarga1(this.plan_selected) || 0
                    : this.getTarifaCarga2(this.plan_selected) || 0,
                icon: 'fi fi-rr-users-alt'
            });
        }
        return items;
    }
    public getDeleteNextMonthlyAmount(): string {
        const nextQuantity = this.beneficiaryDeleteIsSlotOnly
            ? Math.max(this.modifiedBeneficiarySlotCount - 1, this.beneficiariesWorking.length)
            : this.modifiedBeneficiarySlotCount;
        return this.formatPrice(this.getPlanMonthlyAmountByBeneficiaryCount(nextQuantity));
    }
    public getCurrentConditionTotal(): string {
        return this.formatPrice(this.getPlanMonthlyAmountByBeneficiaryCount(this.getCurrentConditionBeneficiaryCount()));
    }
    public getNewConditionTotal(): string {
        return this.formatPrice(this.getPlanMonthlyAmountByBeneficiaryCount(this.getNewConditionBeneficiaryCount()));
    }
    private getPlanChangeCurrentMonthlyAmount(): number {
        return this.getPlanMonthlyAmountByBeneficiaryCount(this.getCurrentConditionBeneficiaryCount());
    }
    private getPlanChangeNewMonthlyAmount(): number {
        return this.getPlanMonthlyAmountByBeneficiaryCount(this.getNewConditionBeneficiaryCount());
    }
    public getPlanChangeAmountDelta(): number {
        return (this.getPlanChangeNewMonthlyAmount()
            -
                this.getPlanChangeCurrentMonthlyAmount());
    }
    public getPlanChangeSummarySubtitle(): string {
        const action = (this.pendingModifyPlanSubsPayload
            ?.action_request
            || '')
            .toString()
            .toUpperCase();
        const delta = this.getNewConditionBeneficiaryCount()
            -
                this.getCurrentConditionBeneficiaryCount();
        const quantity = Math.abs(delta);
        const beneficiaryText = quantity === 1
            ? 'beneficiario'
            : 'beneficiarios';
        if (delta > 0) {
            return `Sumarás ${quantity} ${beneficiaryText}`;
        }
        if (delta < 0) {
            return `Eliminarás ${quantity} ${beneficiaryText}`;
        }
        if (action === 'DEL_BEN') {
            return 'Vaciarás los datos de 1 beneficiario';
        }
        return 'Actualizarás la condición de tu convenio';
    }
    public getPlanChangeSummaryIcon(): string {
        const delta = this.getNewConditionBeneficiaryCount()
            -
                this.getCurrentConditionBeneficiaryCount();
        if (delta > 0) {
            return 'fi fi-rr-user-add';
        }
        if (delta < 0) {
            return 'fi fi-rs-remove-user';
        }
        return 'fi fi-rr-refresh';
    }
    public getPlanChangeImpactClass(): string {
        const delta = this.getPlanChangeAmountDelta();
        if (delta > 0) {
            return 'increase';
        }
        if (delta < 0) {
            return 'decrease';
        }
        return 'neutral';
    }
    public getPlanChangeImpactIcon(): string {
        const delta = this.getPlanChangeAmountDelta();
        if (delta > 0) {
            return 'fi fi-rr-arrow-small-up';
        }
        if (delta < 0) {
            return 'fi fi-rr-arrow-small-down';
        }
        return 'fi fi-rr-info';
    }
    public getPlanChangeImpactText(): string {
        const delta = this.getPlanChangeAmountDelta();
        const amount = this.formatPrice(Math.abs(delta));
        if (delta > 0) {
            return `Costo adicional de ${amount}/mes`;
        }
        if (delta < 0) {
            return `Ahorras ${amount}/mes`;
        }
        return 'Sin cambio en el valor mensual';
    }
    public getPlanChangeEffectiveDate(): string {
        return this.getPlanAnnualRenewalDate(this.plan_selected);
    }
    public getPlanChangeEffectiveMessage(): string {
        return `Este cambio de tarifa se reflejará a partir del ${this.getPlanChangeEffectiveDate()}, fecha de renovación anual de tu plan.`;
    }
    public getPlanChangeFinalConfirmTitle(): string {
        return 'Confirmar cambios';
    }
    public getPlanChangeFinalConfirmDescription(): string {
        return 'Antes de guardar la solicitud, confirma que deseas aplicar este cambio en tu convenio. La modificación quedará programada para la fecha de renovación anual del plan.';
    }
    // =========================================================
    // DATOS ADICIONALES PLAN
    // =========================================================
    public getPaymentMethod(plan: any): string {
        if (plan?.cus_ben_is_suscription) {
            return 'Suscripción';
        }
        return (plan?.payment_method
            || plan?.payment_method_name
            || plan?.metodo_pago
            || 'Descuento por planilla');
    }
    public getRelationship(beneficiary: any): string {
        return (beneficiary?.relationship
            || beneficiary?.parentesco
            || '—');
    }
    public getBirthdate(beneficiary: any): string {
        return (beneficiary?.use_birthdate
            || beneficiary?.birthdate
            || beneficiary?.fecha_nacimiento
            || '—');
    }
    public getSupportPhone(plan: any): string {
        return (plan?.cus_ben_phone
            || '800 248 030');
    }
    public getSupportEmail(plan: any): string {
        return (plan?.cus_ben_mail_contact
            || plan?.cus_support_email
            || 'soporte@almamedis.cl');
    }
    // =========================================================
    // AGREGAR BENEFICIARIO
    // =========================================================
    public openAddBeneficiary(): void {
        if (!this.canAddBeneficiaries(this.plan_selected)
            || this.hasCancelSubscriptionFutureRequest(this.plan_selected)) {
            return;
        }
        this.editingBeneficiaryIndex =
            null;
        this.editingExistingEmptySlot =
            true;
        this.resetBeneficiaryForm();
        this.showBeneficiaryForm =
            true;
        this.showBeneficiaryModal =
            true;
    }
    public editBeneficiary(index: number): void {
        const beneficiary = this.beneficiariesWorking[index];
        if (!beneficiary) {
            return;
        }
        this.editingBeneficiaryIndex =
            index;
        this.editingExistingEmptySlot =
            false;
        const phoneData = this.getPhoneDataFromBeneficiary(beneficiary);
        this.selectedBeneficiaryAreaCode =
            phoneData.areaCode
                || this.selectedBeneficiaryAreaCode;
        this.beneficiaryForm =
            this.createBeneficiaryForm({
                use_rut: beneficiary.use_rut || '',
                use_name: beneficiary.use_name || '',
                use_paternal_surname: beneficiary.use_paternal_surname || '',
                use_maternal_surname: beneficiary.use_maternal_surname || '',
                use_email: beneficiary.use_email || '',
                phone_code: this.selectedBeneficiaryAreaCode
                    .cou_phone_code,
                use_phone: phoneData.phone || '',
                use_birthdate: this.getBirthdateForInput(beneficiary),
                relationship: this.getRelationship(beneficiary) === '—'
                    ? ''
                    : this.getRelationship(beneficiary)
            });
        this.setBeneficiaryTelefonoValidators(this.selectedBeneficiaryAreaCode);
        this.refreshBeneficiaryRutValidation();
        this.showBeneficiaryForm =
            true;
        this.showBeneficiaryModal =
            true;
    }
    public deleteBeneficiary(index: number): void {
        this.beneficiariesWorking.splice(index, 1);
    }
    public cancelBeneficiaryForm(): void {
        this.closeBeneficiaryModal();
    }
    public closeBeneficiaryModal(): void {
        this.resetBeneficiaryForm();
        this.showBeneficiaryForm =
            false;
        this.showBeneficiaryModal =
            false;
        this.editingBeneficiaryIndex =
            null;
        this.addingNewSlotInModify =
            false;
        this.editingExistingEmptySlot =
            false;
    }
    // =========================================================
    // TITULAR BEN ID
    // =========================================================
    private getTitularBenId(plan: any): number {
        const planBenId = Number(plan?.ben_id
            || 0);
        if (planBenId) {
            return planBenId;
        }
        const beneficiarios = Array.isArray(plan?.beneficiarios)
            ? plan.beneficiarios
            : [];
        const titular = beneficiarios.find((beneficiary: any) => {
            return Number(beneficiary?.ben_use_id)
                ===
                    Number(beneficiary?.ben_main_use_id
                        || plan?.ben_main_use_id);
        });
        return Number(titular?.ben_id
            || 0);
    }
    // =========================================================
    // PAYLOAD AGREGAR BENEFICIARIO
    // =========================================================
    private buildAddBeneficiaryPlanSubsMPPayload(formData: any): any {
        return {
            cus_ben_id: Number(this.plan_selected
                ?.cus_ben_id),
            ben_id: this.getTitularBenId(this.plan_selected),
            datosBeneficiario: this.buildDatosBeneficiarioFromForm(formData)
        };
    }
    private validateAddBeneficiaryPlanSubsMPPayload(payload: any): boolean {
        return !!(payload?.cus_ben_id
            && payload?.ben_id
            && Array.isArray(payload?.datosBeneficiario)
            && payload.datosBeneficiario.length > 0
            && payload.datosBeneficiario[0]?.rutBen
            && payload.datosBeneficiario[0]?.telefonoBen
            && payload.datosBeneficiario[0]?.nameBen
            && payload.datosBeneficiario[0]?.paternalSurNameBen
            && payload.datosBeneficiario[0]?.birthDateBen
            && payload.datosBeneficiario[0]?.mailBen);
    }
    // =========================================================
    // PAYLOAD EDITAR BENEFICIARIO
    // =========================================================
    private buildEditBeneficiarySubsPayload(formData: any, beneficiary: any): any {
        return {
            ben_use_id: Number(beneficiary?.ben_use_id),
            datosBeneficiario: {
                rutBen: this.cleanString(beneficiary?.use_rut
                    || formData.use_rut),
                telefonoBen: this.cleanOnlyNumbers(formData.use_phone),
                nameBen: this.cleanString(formData.use_name),
                paternalSurNameBen: this.cleanString(formData.use_paternal_surname),
                maternalSurNameBen: this.cleanString(formData.use_maternal_surname),
                birthDateBen: formData.use_birthdate
                    || null,
                mailBen: this.cleanString(formData.use_email)
            }
        };
    }
    private validateEditBeneficiarySubsPayload(payload: any): boolean {
        return !!(payload?.ben_use_id
            && payload?.datosBeneficiario
            && payload.datosBeneficiario?.rutBen
            && payload.datosBeneficiario?.telefonoBen
            && payload.datosBeneficiario?.nameBen
            && payload.datosBeneficiario?.paternalSurNameBen
            && payload.datosBeneficiario?.birthDateBen
            && payload.datosBeneficiario?.mailBen);
    }
    private buildBeneficiaryLocalFromForm(formData: any, previousBeneficiary: any = {}, response?: any): any {
        return {
            ...previousBeneficiary,
            use_rut: this.formatRut(previousBeneficiary?.use_rut
                || formData.use_rut),
            use_name: formData.use_name,
            use_paternal_surname: formData.use_paternal_surname,
            use_maternal_surname: formData.use_maternal_surname,
            use_email: formData.use_email,
            phone_code: formData.phone_code,
            use_phone: formData.use_phone,
            use_movil_phone: this.getBeneficiaryFullPhone(),
            use_birthdate: formData.use_birthdate,
            relationship: formData.relationship,
            ben_id: previousBeneficiary?.ben_id
                || response?.ben_id
                || response?.data?.ben_id
                || `temp_${new Date().getTime()}`,
            ben_main_use_id: previousBeneficiary?.ben_main_use_id
                || this.plan_selected?.ben_main_use_id,
            ben_use_id: previousBeneficiary?.ben_use_id
                || response?.ben_use_id
                || response?.data?.ben_use_id
                || null,
            ben_creation_date: previousBeneficiary?.ben_creation_date
                || new Date()
                    .toLocaleDateString('es-CL')
        };
    }
    // =========================================================
    // REFRESH PLAN
    // =========================================================
    private getPlanIdentity(plan: any): any {
        return {
            ben_policy_number: plan?.ben_policy_number
                || '',
            cus_ben_id: Number(plan?.cus_ben_id
                || 0),
            ben_id: Number(plan?.ben_id
                || 0)
        };
    }
    private findPlanAfterRefresh(plans: any[], originalPlan: any): any {
        const identity = this.getPlanIdentity(originalPlan);
        return (plans
            || [])
            .find((plan: any) => {
            const samePolicy = identity.ben_policy_number
                &&
                    plan?.ben_policy_number
                        === identity.ben_policy_number;
            const sameCusBen = identity.cus_ben_id
                &&
                    Number(plan?.cus_ben_id)
                        === identity.cus_ben_id;
            const sameBen = identity.ben_id
                &&
                    Number(plan?.ben_id)
                        === identity.ben_id;
            return (samePolicy
                || (sameCusBen
                    && sameBen));
        });
    }
    private async refreshSelectedPlanAfterBeneficiarySave(originalPlan: any): Promise<void> {
        const plans = await this
            .postListPlansXBeneficiaries();
        const updatedPlan = this.findPlanAfterRefresh(plans, originalPlan);
        if (!updatedPlan) {
            return;
        }
        this.plan_selected =
            updatedPlan;
        this.setBeneficiariesWorkingFromPlan();
        /*
         * Importante:
         *
         * Volvemos a calcular pagos programados
         * porque listRequest pudo cambiar.
         */
        this.refreshPaymentHistory();
        if (this.modifyingConvenio) {
            const totalSlotsPlan = this.getBeneficiaryLimit(this.plan_selected);
            const totalBeneficiariosReales = this.beneficiariesWorking.length;
            this.modifiedBeneficiarySlotCount =
                Math.max(totalSlotsPlan, totalBeneficiariosReales);
            this.originalBeneficiarySlotCount =
                this.modifiedBeneficiarySlotCount;
            this.beneficiarySlotCountBeforeLastChange =
                this.modifiedBeneficiarySlotCount;
            this.originalBeneficiariesModifySnapshot =
                this.cloneBeneficiaries(this.beneficiariesWorking);
            this.beneficiariesBeforeLastChange =
                this.cloneBeneficiaries(this.beneficiariesWorking);
        }
    }
    // =========================================================
    // ERRORES BACKEND
    // =========================================================
    private getBackendErrorMessage(error: any, defaultMessage: string): string {
        if (!error) {
            return defaultMessage;
        }
        if (error?.error?.message) {
            return error.error.message;
        }
        if (error?.error?.data?.message) {
            return error.error.data.message;
        }
        if (error?.message) {
            return error.message;
        }
        if (typeof error?.error
            === 'string') {
            try {
                const parsedError = JSON.parse(error.error);
                if (parsedError?.message) {
                    return parsedError.message;
                }
            }
            catch (_) {
                return error.error;
            }
        }
        return defaultMessage;
    }
    // =========================================================
    // HELPERS STRING
    // =========================================================
    private cleanString(value: any): string {
        return (value
            || '')
            .toString()
            .trim();
    }
    private cleanOnlyNumbers(value: any): string {
        return (value
            || '')
            .toString()
            .replace(/\D/g, '');
    }
    private hasBeneficiaryFormData(formData: any): boolean {
        return !!(this.cleanString(formData?.use_rut)
            || this.cleanString(formData?.use_name)
            || this.cleanString(formData?.use_paternal_surname)
            || this.cleanString(formData?.use_maternal_surname)
            || this.cleanString(formData?.use_email)
            || this.cleanString(formData?.use_phone)
            || this.cleanString(formData?.use_birthdate));
    }
    private isBeneficiaryFormEmpty(): boolean {
        if (!this.beneficiaryForm) {
            return true;
        }
        return !this.hasBeneficiaryFormData(this.beneficiaryForm
            .getRawValue());
    }
    public canSubmitBeneficiaryModal(): boolean {
        if (!this.beneficiaryForm
            || this.savingBeneficiary) {
            return false;
        }
        if (this.modifyingConvenio
            && this.addingNewSlotInModify) {
            return (this.isBeneficiaryFormEmpty()
                || this.beneficiaryForm.valid);
        }
        return this.beneficiaryForm.valid;
    }
    // =========================================================
    // TEXTOS MODAL BENEFICIARIO
    // =========================================================
    public getBeneficiaryModalTitle(): string {
        if (this.editingBeneficiaryIndex
            !== null) {
            return 'Editar beneficiario';
        }
        if (this.modifyingConvenio
            && this.addingNewSlotInModify) {
            return 'Agregar cupo o beneficiario';
        }
        if (this.editingExistingEmptySlot) {
            return this.modifyingConvenio
                ? 'Completar cupo disponible'
                : 'Completar datos del beneficiario';
        }
        return 'Agregar beneficiario';
    }
    public getBeneficiaryModalButtonText(): string {
        if (this.savingBeneficiary) {
            return 'Guardando...';
        }
        if (this.modifyingConvenio
            && this.addingNewSlotInModify) {
            return this.isBeneficiaryFormEmpty()
                ? 'Agregar cupo'
                : 'Continuar';
        }
        if (this.editingExistingEmptySlot) {
            return 'Completar datos';
        }
        return this.isRutBeneficiaryReadonly()
            ? 'Guardar cambios'
            : 'Guardar';
    }
    // =========================================================
    // DATOS BENEFICIARIO PAYLOAD
    // =========================================================
    private buildDatosBeneficiarioFromForm(formData: any): any[] {
        return [
            {
                rutBen: this.cleanString(formData.use_rut),
                telefonoBen: this.cleanOnlyNumbers(formData.use_phone),
                nameBen: this.cleanString(formData.use_name),
                paternalSurNameBen: this.cleanString(formData.use_paternal_surname),
                maternalSurNameBen: this.cleanString(formData.use_maternal_surname),
                birthDateBen: formData.use_birthdate
                    || null,
                mailBen: this.cleanString(formData.use_email)
            }
        ];
    }
    // =========================================================
    // PAYLOAD MODIFICAR PLAN
    // =========================================================
    private buildModifyPlanActionPayload(actionRequest: 'ADD_SLOT' | 'ADD_SLOT_BEN' | 'DEL_SLOT' | 'DEL_SLOT_BEN' | 'DEL_BEN', newSlotCount: number, datosBeneficiario: any[] = [], changeBenId?: any): any {
        const paymentPlan = this.getPaymentPlan(this.plan_selected);
        const montoFinal = this.getPlanMonthlyAmountByBeneficiaryCount(newSlotCount);
        const payload: any = {
            sub_pay_token: this.cleanString(paymentPlan?.sub_pay_token
                || paymentPlan?.sub_pay_authorization_code
                || paymentPlan?.sub_pay_provider_response?.id),
            sub_pay_transaction_id: this.cleanString(paymentPlan?.sub_pay_transaction_id
                || paymentPlan
                    ?.sub_pay_provider_response
                    ?.preapproval_plan_id
                || paymentPlan
                    ?.sub_pay_provider_response
                    ?.id),
            sub_pay_provider: this.getPaymentProvider(this.plan_selected),
            monto: montoFinal,
            subs_id: Number(paymentPlan?.subs_id
                || this.plan_selected?.subs_id
                || 0),
            action_request: actionRequest,
            datosBeneficiario: Array.isArray(datosBeneficiario)
                ? datosBeneficiario
                : []
        };
        if (changeBenId !== null
            && changeBenId !== undefined
            && Number(changeBenId) > 0) {
            payload.change_ben_id =
                Number(changeBenId);
        }
        return payload;
    }
    private buildModifyPlanSubsPayload(formData: any, includeBeneficiaryData: boolean, previousSlotCount: number, newSlotCount: number): any {
        const datosBeneficiario = includeBeneficiaryData
            ? this.buildDatosBeneficiarioFromForm(formData)
            : [];
        return this.buildModifyPlanActionPayload(includeBeneficiaryData
            ? 'ADD_SLOT_BEN'
            : 'ADD_SLOT', newSlotCount, datosBeneficiario);
    }
    private validateModifyPlanSubsPayload(payload: any): boolean {
        const baseIsValid = !!(payload?.sub_pay_token
            && payload?.sub_pay_transaction_id
            && this.isSupportedModificationProvider(payload?.sub_pay_provider)
            && payload?.monto
            && payload?.subs_id
            && payload?.action_request
            && Array.isArray(payload?.datosBeneficiario));
        if (!baseIsValid) {
            return false;
        }
        const actionRequest = (payload.action_request
            || '')
            .toString()
            .toUpperCase();
        if (actionRequest === 'ADD_SLOT') {
            return payload
                .datosBeneficiario
                .length === 0;
        }
        if (actionRequest === 'ADD_SLOT_BEN') {
            return !!(payload.datosBeneficiario.length > 0
                && payload.datosBeneficiario[0]?.rutBen
                && payload.datosBeneficiario[0]?.telefonoBen
                && payload.datosBeneficiario[0]?.nameBen
                && payload.datosBeneficiario[0]?.paternalSurNameBen
                && payload.datosBeneficiario[0]?.birthDateBen
                && payload.datosBeneficiario[0]?.mailBen);
        }
        if (actionRequest === 'DEL_SLOT') {
            return (payload.datosBeneficiario.length === 0
                && !payload.change_ben_id);
        }
        if (actionRequest === 'DEL_SLOT_BEN'
            || actionRequest === 'DEL_BEN') {
            return (payload.datosBeneficiario.length === 0
                && !!payload.change_ben_id);
        }
        return false;
    }
    // =========================================================
    // PREPARAR NUEVO CUPO
    // =========================================================
    private prepareModifyPlanNewSlot(): void {
        if (!this.canAddBeneficiaries(this.plan_selected)) {
            return;
        }
        const formData = this.beneficiaryForm
            .getRawValue();
        const formIsEmpty = this.isBeneficiaryFormEmpty();
        if (!formIsEmpty) {
            this.refreshBeneficiaryRutValidation();
            if (this.beneficiaryForm.invalid) {
                this.beneficiaryForm
                    .markAllAsTouched();
                return;
            }
        }
        const projectedSlotCountBeforeChange = this.getNextCycleBeneficiaryCount(this.plan_selected);
        const newSlotCount = projectedSlotCountBeforeChange
            + 1;
        this.beneficiariesBeforeLastChange =
            this.cloneBeneficiaries(this.beneficiariesWorking);
        this.beneficiarySlotCountBeforeLastChange =
            projectedSlotCountBeforeChange;
        this.pendingModifyPlanOriginalPlan =
            {
                ...this.plan_selected
            };
        this.modifiedBeneficiarySlotCount =
            newSlotCount;
        const payload = this.buildModifyPlanSubsPayload(formData, !formIsEmpty, projectedSlotCountBeforeChange, newSlotCount);
        if (!this.validateModifyPlanSubsPayload(payload)) {
            this.beneficiariesWorking =
                this.cloneBeneficiaries(this.beneficiariesBeforeLastChange);
            this.modifiedBeneficiarySlotCount =
                this.beneficiarySlotCountBeforeLastChange;
            this.updateSelectedPlanBeneficiariesLocal();
            Swal.fire({
                icon: 'warning',
                title: 'Datos incompletos',
                text: 'No fue posible armar la información para modificar el plan. Revisa que el plan tenga sub_pay_token, sub_pay_transaction_id, sub_pay_provider, subs_id y monto.',
                confirmButtonText: 'Aceptar'
            });
            return;
        }
        this.pendingModifyPlanSubsPayload =
            payload;
        this.closeBeneficiaryModal();
        this.openPlanChangeComparisonModal('CHANGE');
    }
    // =========================================================
    // COMPLETAR CUPO EXISTENTE
    // =========================================================
    private async prepareEditSlotWithBeneficiary(): Promise<void> {
        if (!this.canAddBeneficiaries(this.plan_selected)) {
            return;
        }
        if (this.savingBeneficiary) {
            return;
        }
        this.refreshBeneficiaryRutValidation();
        if (this.beneficiaryForm.invalid) {
            this.beneficiaryForm
                .markAllAsTouched();
            return;
        }
        const formData = this.beneficiaryForm
            .getRawValue();
        const payload = this.buildAddBeneficiaryPlanSubsMPPayload(formData);
        if (!this.validateAddBeneficiaryPlanSubsMPPayload(payload)) {
            Swal.fire({
                icon: 'warning',
                title: 'Datos incompletos',
                text: 'No fue posible armar la información para completar el cupo. Revisa que exista cus_ben_id, ben_id del titular y los datos del formulario.',
                confirmButtonText: 'Aceptar'
            });
            return;
        }
        this.savingBeneficiary =
            true;
        Swal.fire({
            allowOutsideClick: false,
            html: `
        <div style="margin: 40px 0;">
          <i
            class="material-icons"
            style="
              color:#2BABB7;
              font-size:58px;
              margin-bottom:25px
            ">
            schedule
          </i>

          <h1
            style="
              font-family:Mulish;
              font-style:normal;
              font-weight:700;
              font-size:24px;
              line-height:32px;
              text-align:center;
              color:#171994;
            ">
            Completando datos del beneficiario ...
          </h1>
        </div>
      `,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });
        const originalPlan = {
            ...this.plan_selected
        };
        try {
            await this
                .inscripcionConvenioService
                .postAddbeneficiaryPlanSubsMP(payload);
            this.closeBeneficiaryModal();
            Swal.close();
            await Swal.fire({
                allowOutsideClick: false,
                html: ' <i class="material-icons" style="color:#171994;font-size: 58px;margin: 20px 40px 10px;">mood</i> <br><br>' +
                    ' <h1 style="font-family: Mulish; font-style: normal; font-weight: 800;font-size: 28px; line-height: 48px; align-items: center; text-align: center; color: #171994;" >Datos completados exitosamente</h1> <br>' +
                    ' <p style="font-family: Mulish; font-style: normal; font-weight: normal; font-size: 18px; line-height: 24px; text-align: center; color: #000000;" >El beneficiario quedó registrado en el cupo seleccionado.</p><br>',
                confirmButtonText: 'Aceptar',
                showConfirmButton: false,
                timer: 2500
            });
            await this.refreshSelectedPlanAfterBeneficiarySave(originalPlan);
        }
        catch (error) {
            console.error('Error postAddbeneficiaryPlanSubsMP EDIT_SLOT:', error);
            Swal.close();
            Swal.fire({
                icon: 'error',
                title: 'No fue posible completar el cupo',
                text: this.getBackendErrorMessage(error, 'Ocurrió un problema al completar los datos del beneficiario. Intenta nuevamente.'),
                confirmButtonText: 'Aceptar'
            });
        }
        finally {
            this.savingBeneficiary =
                false;
        }
    }
    // =========================================================
    // CONFIRMAR MODIFICACIÓN PLAN
    // =========================================================
    private async confirmPendingModifyPlanSubs(): Promise<void> {
        if (!this.pendingModifyPlanSubsPayload) {
            return;
        }
        this.savingBeneficiary =
            true;
        Swal.fire({
            allowOutsideClick: false,
            html: `
        <div style="margin: 40px 0;">
          <i
            class="material-icons"
            style="
              color:#2BABB7;
              font-size:58px;
              margin-bottom:25px
            ">
            schedule
          </i>

          <h1
            style="
              font-family:Mulish;
              font-style:normal;
              font-weight:700;
              font-size:24px;
              line-height:32px;
              text-align:center;
              color:#171994;
            ">
            Modificando plan ...
          </h1>
        </div>
      `,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });
        try {
            await this.postModifyPlanByProvider(this.pendingModifyPlanSubsPayload);
            this.closePlanChangeComparisonModal();
            Swal.close();
            await Swal.fire({
                allowOutsideClick: false,
                html: ' <i class="material-icons" style="color:#171994;font-size: 58px;margin: 20px 40px 10px;">mood</i> <br><br>' +
                    ' <h1 style="font-family: Mulish; font-style: normal; font-weight: 800;font-size: 28px; line-height: 48px; align-items: center; text-align: center; color: #171994;" >Plan modificado exitosamente</h1> <br>' +
                    ' <p style="font-family: Mulish; font-style: normal; font-weight: normal; font-size: 18px; line-height: 24px; text-align: center; color: #000000;" ></p><br>',
                confirmButtonText: 'Aceptar',
                showConfirmButton: false,
                timer: 2500
            });
            if (this.pendingModifyPlanOriginalPlan) {
                await this.refreshSelectedPlanAfterBeneficiarySave(this.pendingModifyPlanOriginalPlan);
            }
            this.pendingModifyPlanSubsPayload =
                null;
            this.pendingModifyPlanOriginalPlan =
                null;
        }
        catch (error) {
            console.error('Error modificando plan según proveedor:', error);
            Swal.close();
            Swal.fire({
                icon: 'error',
                title: 'No fue posible modificar el plan',
                text: this.getBackendErrorMessage(error, 'Ocurrió un problema al modificar el plan. Intenta nuevamente.'),
                confirmButtonText: 'Aceptar'
            });
        }
        finally {
            this.savingBeneficiary =
                false;
        }
    }
    // =========================================================
    // GUARDAR BENEFICIARIO
    // =========================================================
    public async saveBeneficiary(): Promise<void> {
        if (this.editingExistingEmptySlot) {
            await this.prepareEditSlotWithBeneficiary();
            return;
        }
        if (this.modifyingConvenio
            && this.addingNewSlotInModify) {
            this.prepareModifyPlanNewSlot();
            return;
        }
        if (this.editingBeneficiaryIndex
            !== null) {
            await this.editBeneficiaryForModifySlot();
            return;
        }
        if (this.modifyingConvenio) {
            await this.saveBeneficiaryForModifySlot();
            return;
        }
        if (!this.canAddBeneficiaries(this.plan_selected)) {
            return;
        }
        if (this.savingBeneficiary) {
            return;
        }
        this.refreshBeneficiaryRutValidation();
        if (this.beneficiaryForm.invalid) {
            this.beneficiaryForm
                .markAllAsTouched();
            return;
        }
        const formData = this.beneficiaryForm
            .getRawValue();
        const payload = this.buildAddBeneficiaryPlanSubsMPPayload(formData);
        if (!this.validateAddBeneficiaryPlanSubsMPPayload(payload)) {
            Swal.fire({
                icon: 'warning',
                title: 'Datos incompletos',
                text: 'No fue posible armar la información del beneficiario. Revisa los datos del plan y del formulario.',
                confirmButtonText: 'Aceptar'
            });
            return;
        }
        this.savingBeneficiary =
            true;
        Swal.fire({
            allowOutsideClick: false,
            html: `
        <div style="margin: 40px 0;">
          <i
            class="material-icons"
            style="
              color:#2BABB7;
              font-size:58px;
              margin-bottom:25px
            ">
            schedule
          </i>

          <h1
            style="
              font-family:Mulish;
              font-style:normal;
              font-weight:700;
              font-size:24px;
              line-height:32px;
              text-align:center;
              color:#171994;
            ">
            Agregando beneficiario ...
          </h1>
        </div>
      `,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });
        try {
            const response: any = await this
                .inscripcionConvenioService
                .postAddbeneficiaryPlanSubsMP(payload);
            const beneficiary = {
                use_rut: this.formatRut(formData.use_rut),
                use_name: formData.use_name,
                use_paternal_surname: formData.use_paternal_surname,
                use_maternal_surname: formData.use_maternal_surname,
                use_email: formData.use_email,
                phone_code: formData.phone_code,
                use_phone: formData.use_phone,
                use_movil_phone: this.getBeneficiaryFullPhone(),
                use_birthdate: formData.use_birthdate,
                relationship: formData.relationship,
                ben_id: response?.ben_id
                    || response?.data?.ben_id
                    || `temp_${new Date().getTime()}`,
                ben_main_use_id: this.plan_selected
                    ?.ben_main_use_id,
                ben_use_id: response?.ben_use_id
                    || response?.data?.ben_use_id
                    || null,
                ben_creation_date: new Date()
                    .toLocaleDateString('es-CL')
            };
            if (this.editingBeneficiaryIndex
                !== null) {
                this.beneficiariesWorking[this.editingBeneficiaryIndex] = {
                    ...this.beneficiariesWorking[this.editingBeneficiaryIndex],
                    ...beneficiary
                };
            }
            else {
                this.beneficiariesWorking.push(beneficiary);
            }
            this.updateSelectedPlanBeneficiariesLocal();
            this.closeBeneficiaryModal();
            Swal.close();
            await Swal.fire({
                allowOutsideClick: false,
                html: ' <i class="material-icons" style="color:#171994;font-size: 58px;margin: 20px 40px 10px;">mood</i> <br><br>' +
                    ' <h1 style="font-family: Mulish; font-style: normal; font-weight: 800;font-size: 28px; line-height: 48px; align-items: center; text-align: center; color: #171994;" >Beneficio ingresado exitosamente</h1> <br>' +
                    ' <p style="font-family: Mulish; font-style: normal; font-weight: normal; font-size: 18px; line-height: 24px; text-align: center; color: #000000;" ></p><br>',
                confirmButtonText: 'Aceptar',
                showConfirmButton: false,
                timer: 2500
            });
            await this.refreshSelectedPlanAfterBeneficiarySave({
                ...this.plan_selected
            });
        }
        catch (error) {
            console.error('Error postAddbeneficiaryPlanSubsMP:', error);
            Swal.close();
            Swal.fire({
                icon: 'error',
                title: 'No fue posible agregar el beneficiario',
                text: 'Ocurrió un problema al guardar el beneficiario. Intenta nuevamente.',
                confirmButtonText: 'Aceptar'
            });
        }
        finally {
            this.savingBeneficiary =
                false;
        }
    }
    // =========================================================
    // CAMBIOS LOCALES BENEFICIARIO
    // =========================================================
    public cancelBeneficiaryChanges(): void {
        this.setBeneficiariesWorkingFromPlan();
        this.activeDetailTab =
            'detail';
        this.closeBeneficiaryModal();
    }
    public saveBeneficiaryChanges(): void {
        console.log('Guardar cambios beneficiarios:', {
            plan: this.plan_selected,
            beneficiaries: this.beneficiariesWorking
        });
        this.updateSelectedPlanBeneficiariesLocal();
        this.activeDetailTab =
            'beneficiaries';
        this.closeBeneficiaryModal();
    }
    public isBeneficiaryFormValid(): boolean {
        return this.beneficiaryForm.valid;
    }
    private setBeneficiariesWorkingFromPlan(): void {
        this.beneficiariesWorking =
            this
                .getAssociatedBeneficiaries(this.plan_selected)
                .map((beneficiary: any) => ({
                ...beneficiary
            }));
    }
    private updateSelectedPlanBeneficiariesLocal(): void {
        const originalBeneficiaries = Array.isArray(this.plan_selected?.beneficiarios)
            ? this.plan_selected.beneficiarios
            : [];
        const holderRows = originalBeneficiaries.filter((beneficiary: any) => {
            return Number(beneficiary?.ben_use_id)
                ===
                    Number(beneficiary?.ben_main_use_id
                        || this.plan_selected?.ben_main_use_id);
        });
        this.plan_selected.beneficiarios = [
            ...holderRows,
            ...this.beneficiariesWorking.map((beneficiary: any, index: number) => ({
                ...beneficiary,
                ben_id: beneficiary?.ben_id
                    || `temp_${index + 1}`,
                ben_main_use_id: beneficiary?.ben_main_use_id
                    || this.plan_selected?.ben_main_use_id,
                ben_use_id: beneficiary?.ben_use_id
                    || `temp_use_${index + 1}`
            }))
        ];
        const planIndex = this.planes.findIndex((plan: any) => {
            return (plan?.ben_policy_number
                === this.plan_selected?.ben_policy_number
                ||
                    plan?.cus_ben_id
                        === this.plan_selected?.cus_ben_id);
        });
        if (planIndex >= 0) {
            this.planes[planIndex] = {
                ...this.planes[planIndex],
                beneficiarios: this.plan_selected
                    .beneficiarios
            };
        }
    }
    private updateSelectedPlanSlotLimitLocal(slotCount: number): void {
        const normalizedSlotCount = Math.max(0, Number(slotCount
            || 0));
        const newTotalAmount = this.getPlanMonthlyAmountByBeneficiaryCount(normalizedSlotCount);
        this.plan_selected = {
            ...this.plan_selected,
            sub_cant_beneficiarios: normalizedSlotCount
        };
        if (Array.isArray(this.plan_selected?.planPagos)
            && this.plan_selected.planPagos.length > 0) {
            this.plan_selected.planPagos =
                this.plan_selected.planPagos.map((payment: any, index: number) => {
                    if (index !== 0) {
                        return payment;
                    }
                    return {
                        ...payment,
                        sub_cant_beneficiarios: normalizedSlotCount,
                        sub_pay_total_amount: newTotalAmount
                    };
                });
        }
        const planIndex = this.planes.findIndex((plan: any) => {
            return (plan?.ben_policy_number
                === this.plan_selected?.ben_policy_number
                ||
                    plan?.cus_ben_id
                        === this.plan_selected?.cus_ben_id);
        });
        if (planIndex >= 0) {
            this.planes[planIndex] = {
                ...this.planes[planIndex],
                sub_cant_beneficiarios: normalizedSlotCount,
                planPagos: this.plan_selected.planPagos,
                beneficiarios: this.plan_selected.beneficiarios
            };
        }
        this.refreshPaymentHistory();
    }
    // =========================================================
    // RESET BENEFICIARIO
    // =========================================================
    private resetBeneficiaryForm(): void {
        const codigoChile = this.areaCodes.find((item: any) => String(item.cou_phone_code) === '56');
        this.selectedBeneficiaryAreaCode =
            codigoChile
                || this.selectedBeneficiaryAreaCode;
        this.beneficiaryForm =
            this.createBeneficiaryForm({
                phone_code: this.selectedBeneficiaryAreaCode
                    .cou_phone_code
            });
        this.setBeneficiaryTelefonoValidators(this.selectedBeneficiaryAreaCode);
        this.beneficiaryFlagDropdownOpen =
            false;
    }
    // =========================================================
    // VALIDACIONES INPUT
    // =========================================================
    public allowOnlyLetters(event: KeyboardEvent): void {
        const regex = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ'´\s]*$/;
        if (!regex.test(event.key)) {
            event.preventDefault();
        }
    }
    public allowOnlyNumbers(event: KeyboardEvent): void {
        if (!/[0-9]/.test(event.key)) {
            event.preventDefault();
        }
    }
    public allowOnlyRutChars(event: KeyboardEvent): void {
        const regex = /^[0-9kK.\-]$/;
        if (!regex.test(event.key)) {
            event.preventDefault();
        }
    }
    // =========================================================
    // RUT BENEFICIARIO
    // =========================================================
    public onBeneficiaryRutBlur(): void {
        const rutCtrl = this.beneficiaryForm.get('use_rut');
        if (!rutCtrl) {
            return;
        }
        rutCtrl.setValue(this.formatRut(rutCtrl.value
            || ''), {
            emitEvent: false
        });
        rutCtrl.markAsTouched();
        rutCtrl.updateValueAndValidity();
        this.refreshBeneficiaryRutValidation();
    }
    // =========================================================
    // TELÉFONO
    // =========================================================
    public onBeneficiaryTelefonoInput(event: any): void {
        const value = (event.target.value
            || '')
            .toString()
            .replace(/\D/g, '');
        this.beneficiaryForm
            .get('use_phone')
            ?.setValue(value, {
            emitEvent: false
        });
    }
    public toggleBeneficiaryFlagDropdown(): void {
        this.beneficiaryFlagDropdownOpen =
            !this.beneficiaryFlagDropdownOpen;
    }
    public selectBeneficiaryAreaCode(areaCode: any): void {
        this.selectedBeneficiaryAreaCode =
            areaCode;
        this.beneficiaryFlagDropdownOpen =
            false;
        this.beneficiaryForm.patchValue({
            phone_code: areaCode.cou_phone_code,
            use_phone: ''
        });
        this.setBeneficiaryTelefonoValidators(areaCode);
    }
    private setBeneficiaryTelefonoValidators(areaCode: any): void {
        const telefonoCtrl = this.beneficiaryForm
            ?.get('use_phone');
        if (!telefonoCtrl) {
            return;
        }
        const minPhone = Number(areaCode?.cou_min_phone
            || 8);
        const maxPhone = Number(areaCode?.cou_max_phone
            || 15);
        telefonoCtrl.setValidators([
            Validators.required,
            Validators.pattern('^[0-9]*$'),
            Validators.minLength(minPhone),
            Validators.maxLength(maxPhone)
        ]);
        telefonoCtrl.updateValueAndValidity();
    }
    public beneficiaryControlInvalid(controlName: string): boolean {
        const control = this.beneficiaryForm.get(controlName);
        return !!control
            && control.invalid
            && control.touched;
    }
    public getBeneficiaryPhoneHelpText(): string {
        if (!this.selectedBeneficiaryAreaCode) {
            return '';
        }
        return `Ingrese número entre ${this.selectedBeneficiaryAreaCode.cou_min_phone} y ${this.selectedBeneficiaryAreaCode.cou_max_phone} dígitos.`;
    }
    private getBeneficiaryFullPhone(): string {
        const formData = this.beneficiaryForm
            .getRawValue();
        const codigo = (formData.phone_code
            || '')
            .toString()
            .replace('+', '');
        const telefono = (formData.use_phone
            || '')
            .toString()
            .replace(/\D/g, '');
        if (!codigo
            && !telefono) {
            return '';
        }
        return `+${codigo}${telefono}`;
    }
    private getPhoneDataFromBeneficiary(beneficiary: any): any {
        const rawCode = (beneficiary?.phone_code
            || beneficiary?.use_phone_code
            || '')
            .toString()
            .replace(/\D/g, '');
        const rawPhone = (beneficiary?.use_phone
            || beneficiary?.use_movil_phone
            || '')
            .toString()
            .replace(/\D/g, '');
        let areaCode = rawCode
            ? this.areaCodes.find((item: any) => String(item.cou_phone_code) === rawCode)
            : null;
        if (!areaCode
            && rawPhone) {
            areaCode =
                this.areaCodes.find((item: any) => rawPhone.startsWith(String(item.cou_phone_code)));
        }
        if (!areaCode) {
            areaCode =
                this.selectedBeneficiaryAreaCode;
        }
        const code = String(areaCode?.cou_phone_code
            || '56');
        const phone = rawPhone.startsWith(code)
            ? rawPhone.substring(code.length)
            : rawPhone;
        return {
            areaCode,
            phone
        };
    }
    // =========================================================
    // VALIDAR RUT
    // =========================================================
    public rutChilenoValidator(control: AbstractControl): ValidationErrors | null {
        const value = control.value;
        if (!value) {
            return null;
        }
        const rut = this.normalizeRut(value);
        if (rut.length < 2) {
            return {
                rutInvalido: true
            };
        }
        const cuerpo = rut.slice(0, -1);
        const dv = rut
            .slice(-1)
            .toUpperCase();
        if (!/^\d+$/.test(cuerpo)) {
            return {
                rutInvalido: true
            };
        }
        let suma = 0;
        let multiplo = 2;
        for (let i = cuerpo.length - 1; i >= 0; i--) {
            suma +=
                Number(cuerpo.charAt(i))
                    *
                        multiplo;
            multiplo =
                multiplo < 7
                    ? multiplo + 1
                    : 2;
        }
        const dvEsperadoNumero = 11
            -
                (suma % 11);
        let dvEsperado = '';
        if (dvEsperadoNumero === 11) {
            dvEsperado =
                '0';
        }
        else if (dvEsperadoNumero === 10) {
            dvEsperado =
                'K';
        }
        else {
            dvEsperado =
                String(dvEsperadoNumero);
        }
        return dv === dvEsperado
            ? null
            : {
                rutInvalido: true
            };
    }
    // =========================================================
    // VALIDAR EMAIL
    // =========================================================
    public emailFormatoValidator(control: AbstractControl): ValidationErrors | null {
        const value = (control.value
            || '')
            .toString()
            .trim();
        if (!value) {
            return null;
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
        return emailRegex.test(value)
            ? null
            : {
                emailFormatoInvalido: true
            };
    }
    // =========================================================
    // VALIDAR FECHA
    // =========================================================
    public fechaNoFuturaValidator(control: AbstractControl): ValidationErrors | null {
        const value = control.value;
        if (!value) {
            return null;
        }
        const fechaIngresada = new Date(`${value}T00:00:00`);
        if (isNaN(fechaIngresada.getTime())) {
            return {
                fechaInvalida: true
            };
        }
        const hoy = new Date();
        hoy.setHours(0, 0, 0, 0);
        return fechaIngresada > hoy
            ? {
                fechaMayorActual: true
            }
            : null;
    }
    private getTodayIsoDate(): string {
        const hoy = new Date();
        const year = hoy.getFullYear();
        const month = String(hoy.getMonth() + 1)
            .padStart(2, '0');
        const day = String(hoy.getDate())
            .padStart(2, '0');
        return `${year}-${month}-${day}`;
    }
    // =========================================================
    // RUT HELPERS
    // =========================================================
    private formatRut(rut: any): string {
        const clean = this.normalizeRut(rut);
        if (!clean) {
            return '';
        }
        if (clean.length === 1) {
            return clean;
        }
        const cuerpo = clean.slice(0, -1);
        const dv = clean.slice(-1);
        return `${cuerpo}-${dv}`;
    }
    private normalizeRut(rut: any): string {
        return (rut
            || '')
            .toString()
            .replace(/[^0-9kK]/g, '')
            .toUpperCase();
    }
    private beneficiaryRutPlanValidator(control: AbstractControl): ValidationErrors | null {
        const rutBeneficiario = this.normalizeRut(control.value);
        if (!rutBeneficiario
            || rutBeneficiario.length < 2) {
            return null;
        }
        const rutTitular = this.getRutTitularPlanNormalizado();
        if (rutTitular
            && rutBeneficiario === rutTitular) {
            return {
                rutIgualTitular: true
            };
        }
        if (this.existeRutBeneficiarioEnPlan(rutBeneficiario)) {
            return {
                rutBeneficiarioDuplicado: true
            };
        }
        return null;
    }
    private getRutTitularPlanNormalizado(): string {
        const rutDesdePlan = this.normalizeRut(this.plan_selected?.use_rut);
        if (rutDesdePlan) {
            return rutDesdePlan;
        }
        const beneficiarios = Array.isArray(this.plan_selected?.beneficiarios)
            ? this.plan_selected.beneficiarios
            : [];
        const titular = beneficiarios.find((beneficiario: any) => {
            return Number(beneficiario?.ben_use_id)
                ===
                    Number(beneficiario?.ben_main_use_id
                        || this.plan_selected?.ben_main_use_id);
        });
        return this.normalizeRut(titular?.use_rut);
    }
    private existeRutBeneficiarioEnPlan(rutNormalizado: string): boolean {
        const beneficiariosActuales = this.beneficiariesWorking.length > 0
            ? this.beneficiariesWorking
            : this.getAssociatedBeneficiaries(this.plan_selected);
        return beneficiariosActuales.some((beneficiario: any, index: number) => {
            if (this.editingBeneficiaryIndex !== null
                && index === this.editingBeneficiaryIndex) {
                return false;
            }
            const rutExistente = this.normalizeRut(beneficiario?.use_rut);
            return (!!rutExistente
                && rutExistente === rutNormalizado);
        });
    }
    private refreshBeneficiaryRutValidation(): void {
        const rutControl = this.beneficiaryForm
            ?.get('use_rut');
        if (!rutControl) {
            return;
        }
        rutControl.updateValueAndValidity({
            emitEvent: false
        });
    }
    // =========================================================
    // FECHA NACIMIENTO
    // =========================================================
    private getBirthdateForInput(beneficiary: any): string {
        const value = beneficiary?.use_birthdate
            || beneficiary?.birthdate
            || beneficiary?.fecha_nacimiento
            || '';
        if (!value) {
            return '';
        }
        if (typeof value === 'string'
            && value.includes('/')) {
            const parts = value.split('/');
            if (parts.length === 3) {
                return `${parts[2]}-${parts[1].padStart(2, '0')}-${parts[0].padStart(2, '0')}`;
            }
        }
        if (typeof value === 'string'
            && value.length >= 10) {
            return value.substring(0, 10);
        }
        return '';
    }
    private isValidEmail(email: string): boolean {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email
            || '');
    }
    // =========================================================
    // TEXTO
    // =========================================================
    private normalizeText(value: any): string {
        return (value
            || '')
            .toString()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase();
    }
    private parseBooleanValue(value: any): boolean {
        if (value === true
            || value === 1) {
            return true;
        }
        if (value === false
            || value === 0
            || value === null
            || value === undefined
            || value === '') {
            return false;
        }
        const normalizedValue = value
            .toString()
            .trim()
            .toLowerCase();
        return [
            'true',
            '1',
            'si',
            'sí',
            's',
            'yes',
            'y'
        ]
            .includes(normalizedValue);
    }
    // =========================================================
    // SUSCRIPCIÓN
    // =========================================================
    public isSubscriptionPlan(plan: any): boolean {
        return this.parseBooleanValue(plan?.cus_ben_is_suscription);
    }
    public canAddBeneficiaries(plan: any): boolean {
        return (plan?.is_titular === true
            &&
                this.isSubscriptionPlan(plan));
    }
    // =========================================================
    // TÉRMINOS Y CONDICIONES
    // =========================================================
    public openTermsAndConditionsModal(): void {
        if (!this.plan_selected
            ?.cus_ben_is_suscription) {
            return;
        }
        this.showTermsAndConditionsModal =
            true;
    }
    public closeTermsAndConditionsModal(): void {
        this.showTermsAndConditionsModal =
            false;
    }
    // =========================================================
    // MODIFICAR MEDIO DE PAGO
    // MERCADO_PAGO -> modal/tokenización actual
    // VIRTUAL_POS  -> solicita link de cambio de tarjeta y redirige
    // =========================================================
    public async openPaymentMethodModal(): Promise<void> {
        if (this.tokenizingPaymentMethod || this.initializingPaymentMethod) return;

        const provider = this.getPaymentProvider(this.plan_selected);

        if (provider === 'VIRTUAL_POS') {
            await this.changeVirtualPosPaymentMethod();
            return;
        }

        if (provider !== 'MERCADO_PAGO') {
            Swal.fire({
                icon: 'warning',
                title: 'Medio de pago no disponible',
                text: 'No fue posible identificar un proveedor de pago compatible para esta suscripción.',
                confirmButtonText: 'Aceptar'
            });
            return;
        }

        this.destroyMercadoPagoSecureFields();
        this.paymentMethodError = '';
        this.generatedCardTokenId = '';
        this.initializingPaymentMethod = false;
        this.paymentMethodModalStep = 'options';
        this.showPaymentMethodModal = true;
    }

    private async changeVirtualPosPaymentMethod(): Promise<void> {
        const paymentPlan = this.getPaymentPlan(this.plan_selected);
        const subPayToken = this.cleanString(paymentPlan?.sub_pay_token);

        if (!subPayToken) {
            Swal.fire({
                icon: 'warning',
                title: 'Datos de suscripción incompletos',
                text: 'No se encontró el sub_pay_token asociado a la suscripción de VirtualPOS.',
                confirmButtonText: 'Aceptar'
            });
            return;
        }

        this.initializingPaymentMethod = true;
        this.paymentMethodError = '';

        try {
            const response: any = await this.inscripcionConvenioService.postChangeCardVP({
                sub_pay_token: subPayToken
            });

            if (response?.ok === false) {
                throw new Error(response?.message || 'VirtualPOS no pudo generar el enlace para cambiar la tarjeta.');
            }

            const changeCardUrl = this.cleanString(
                response?.url
                || response?.data?.url
                || response?.change_card_url
                || response?.data?.change_card_url
            );

            if (!changeCardUrl) {
                throw new Error('VirtualPOS no devolvió la URL para cambiar el medio de pago.');
            }

            window.location.href = changeCardUrl;
        } catch (error) {
            console.error('[PlansComponent] Error solicitando cambio de tarjeta VirtualPOS:', error);
            Swal.fire({
                icon: 'error',
                title: 'No fue posible modificar el medio de pago',
                text: this.getBackendErrorMessage(
                    error,
                    'Ocurrió un problema al generar el enlace de cambio de tarjeta en VirtualPOS. Intenta nuevamente.'
                ),
                confirmButtonText: 'Aceptar'
            });
        } finally {
            this.initializingPaymentMethod = false;
        }
    }
    public closePaymentMethodModal(): void {
        if (this.tokenizingPaymentMethod)
            return;
        this.showPaymentMethodModal = false;
        this.paymentMethodModalStep = 'options';
        this.initializingPaymentMethod = false;
        this.paymentMethodError = '';
        this.generatedCardTokenId = '';
        this.paymentToRegularize = null;
        this.destroyMercadoPagoSecureFields();
    }
    public openMercadoPagoPaymentGuide(): void {
        if (this.tokenizingPaymentMethod)
            return;
        this.destroyMercadoPagoSecureFields();
        this.paymentMethodError = '';
        this.initializingPaymentMethod = false;
        this.paymentMethodModalStep = 'mercadoPago';
    }
    public async openPaymentMethodInternalForm(): Promise<void> {
        if (this.initializingPaymentMethod || this.tokenizingPaymentMethod)
            return;
        const paymentPlan = this.getPaymentPlan(this.plan_selected);
        const publicKey = this.getMercadoPagoPublicKey(this.plan_selected);
        if (!publicKey) {
            Swal.fire({
                icon: 'warning',
                title: 'Configuración de pago no disponible',
                text: 'No se encontró la Public Key de Mercado Pago asociada a esta suscripción.',
                confirmButtonText: 'Aceptar'
            });
            return;
        }
        if (!Number(paymentPlan?.subs_id) || !Number(paymentPlan?.sub_pay_id)) {
            Swal.fire({
                icon: 'warning',
                title: 'Datos de suscripción incompletos',
                text: 'No fue posible identificar la suscripción o el pago asociado.',
                confirmButtonText: 'Aceptar'
            });
            return;
        }
        this.destroyMercadoPagoSecureFields();
        this.paymentMethodError = '';
        this.generatedCardTokenId = '';
        this.paymentMethodModalStep = 'form';
        this.initializingPaymentMethod = true;
        try {
            await this.loadMercadoPagoSdk();
            await this.waitForPaymentMethodModalDom();
            this.initializeMercadoPagoSecureFields(publicKey);
        }
        catch (error) {
            console.error('[PlansComponent] Error inicializando Mercado Pago:', error);
            this.paymentMethodError = 'No fue posible cargar el formulario seguro de Mercado Pago.';
        }
        finally {
            this.initializingPaymentMethod = false;
        }
    }
    public backToPaymentMethodOptions(): void {
        if (this.tokenizingPaymentMethod)
            return;
        this.destroyMercadoPagoSecureFields();
        this.initializingPaymentMethod = false;
        this.paymentMethodError = '';
        this.generatedCardTokenId = '';
        this.paymentMethodModalStep = 'options';
    }
    public goToMercadoPago(): void {
        window.open('https://www.mercadopago.cl/', '_blank', 'noopener,noreferrer');
    }
    private closeAllPaymentMethodModals(): void {
        this.showPaymentMethodModal = false;
        this.paymentMethodModalStep = 'options';
        this.initializingPaymentMethod = false;
        this.tokenizingPaymentMethod = false;
        this.paymentMethodError = '';
        this.generatedCardTokenId = '';
        this.paymentToRegularize = null;
        this.destroyMercadoPagoSecureFields();
        Swal.close();
    }
    private getMercadoPagoPublicKey(plan: any): string {
        return String(this.getPaymentPlan(plan)?.publicKeyMP || '').trim();
    }
    private getPaymentCardHolderName(): string {
        const plan = this.plan_selected || {};
        const user = this.usuario || {};
        return [
            plan?.use_name || user?.use_name || '',
            plan?.use_paternal_surname || user?.use_paternal_surname || '',
            plan?.use_maternal_surname || user?.use_maternal_surname || ''
        ]
            .filter((value: any) => !!String(value || '').trim())
            .join(' ')
            .trim();
    }
    private getPaymentCardHolderRut(): string {
        const rut = String(this.plan_selected?.use_rut ||
            this.usuario?.use_rut ||
            '');
        return rut.replace(/[^0-9kK]/g, '').toUpperCase();
    }
    private loadMercadoPagoSdk(): Promise<void> {
        const win = window as any;
        if (win.MercadoPago)
            return Promise.resolve();
        if (this.mercadoPagoSdkPromise)
            return this.mercadoPagoSdkPromise;
        this.mercadoPagoSdkPromise = new Promise<void>((resolve, reject) => {
            const existingScript = document.querySelector('script[src="https://sdk.mercadopago.com/js/v2"]') as HTMLScriptElement | null;
            const onLoad = () => (window as any).MercadoPago
                ? resolve()
                : reject(new Error('MercadoPago.js cargó, pero MercadoPago no está disponible.'));
            const onError = () => reject(new Error('No fue posible cargar MercadoPago.js.'));
            if (existingScript) {
                if ((window as any).MercadoPago) {
                    resolve();
                    return;
                }
                existingScript.addEventListener('load', onLoad, { once: true });
                existingScript.addEventListener('error', onError, { once: true });
                return;
            }
            const script = document.createElement('script');
            script.src = 'https://sdk.mercadopago.com/js/v2';
            script.async = true;
            script.addEventListener('load', onLoad, { once: true });
            script.addEventListener('error', onError, { once: true });
            document.body.appendChild(script);
        }).catch((error) => {
            this.mercadoPagoSdkPromise = null;
            throw error;
        });
        return this.mercadoPagoSdkPromise;
    }
    private waitForPaymentMethodModalDom(): Promise<void> {
        return new Promise(resolve => setTimeout(resolve, 50));
    }
    private initializeMercadoPagoSecureFields(publicKey: string): void {
        const MercadoPago = (window as any).MercadoPago;
        if (!MercadoPago) {
            throw new Error('MercadoPago.js no está disponible.');
        }
        const cardNumberContainer = document.getElementById('mp-card-number');
        const expirationContainer = document.getElementById('mp-expiration-date');
        const securityCodeContainer = document.getElementById('mp-security-code');
        if (!cardNumberContainer || !expirationContainer || !securityCodeContainer) {
            throw new Error('No se encontraron los contenedores de Mercado Pago en el modal.');
        }
        this.mercadoPagoInstance = new MercadoPago(publicKey, { locale: 'es-CL' });
        this.mercadoPagoCardNumberField = this.mercadoPagoInstance.fields
            .create('cardNumber', { placeholder: 'Número de tarjeta' })
            .mount('mp-card-number');
        this.mercadoPagoExpirationDateField = this.mercadoPagoInstance.fields
            .create('expirationDate', { placeholder: 'MM/AA' })
            .mount('mp-expiration-date');
        this.mercadoPagoSecurityCodeField = this.mercadoPagoInstance.fields
            .create('securityCode', { placeholder: 'CVV' })
            .mount('mp-security-code');
    }
    public async generateMercadoPagoCardToken(event?: Event): Promise<void> {
        if (event)
            event.preventDefault();
        if (this.tokenizingPaymentMethod || !this.mercadoPagoInstance)
            return;
        const cardholderName = this.getPaymentCardHolderName();
        const identificationNumber = this.getPaymentCardHolderRut();
        if (!cardholderName || !identificationNumber) {
            this.paymentMethodError = 'No fue posible obtener los datos del titular necesarios para validar la tarjeta.';
            return;
        }
        const paymentPlan = this.getPaymentPlan(this.plan_selected);
        const subsId = Number(paymentPlan?.subs_id || 0);
        const subPayId = Number(paymentPlan?.sub_pay_id || 0);
        if (!subsId || !subPayId) {
            this.paymentMethodError = 'No fue posible identificar la suscripción o el pago asociado.';
            return;
        }
        this.tokenizingPaymentMethod = true;
        this.paymentMethodError = '';
        try {
            const tokenResponse = await this.mercadoPagoInstance.fields.createCardToken({
                cardholderName,
                identificationType: 'RUT',
                identificationNumber
            });
            const cardTokenId = String(tokenResponse?.id || '').trim();
            if (!cardTokenId) {
                this.paymentMethodError = 'Revisa el número de tarjeta, fecha de vencimiento y CVV.';
                return;
            }
            this.generatedCardTokenId = cardTokenId;
            const response: any = await this.inscripcionConvenioService.postChangeCardPayPlan({
                subs_id: subsId,
                sub_pay_id: subPayId,
                card_token_id: cardTokenId
            });
            if (response?.ok === true) {
                this.closeAllPaymentMethodModals();
                await Swal.fire({
                    allowOutsideClick: true,
                    html: ' <i class="material-icons" style="color:#171994;font-size:58px;margin:20px 40px 10px;">mood</i><br><br>' +
                        ' <h1 style="font-family:Mulish;font-style:normal;font-weight:800;font-size:28px;line-height:48px;text-align:center;color:#171994;">Medio de pago actualizado</h1><br>' +
                        ' <p style="font-family:Mulish;font-style:normal;font-weight:normal;font-size:18px;line-height:24px;text-align:center;color:#000000;">' +
                        (response?.message || 'La tarjeta fue cambiada correctamente.') +
                        '</p><br>',
                    showConfirmButton: false,
                    timer: 2500
                });
                return;
            }
            this.generatedCardTokenId = '';
            this.paymentMethodError =
                response?.message ||
                    'No fue posible actualizar el medio de pago. Ingresa nuevamente los datos de la tarjeta.';
        }
        catch (error) {
            console.error('[PlansComponent] Error cambiando tarjeta:', error);
            this.generatedCardTokenId = '';
            this.paymentMethodError = this.getBackendErrorMessage(error, 'No fue posible actualizar el medio de pago. Revisa los datos e intenta nuevamente.');
        }
        finally {
            this.tokenizingPaymentMethod = false;
        }
    }
    private destroyMercadoPagoSecureFields(): void {
        [
            this.mercadoPagoCardNumberField,
            this.mercadoPagoExpirationDateField,
            this.mercadoPagoSecurityCodeField
        ].forEach((field: any) => {
            try {
                if (field && typeof field.unmount === 'function') {
                    field.unmount();
                }
            }
            catch (error) {
                console.warn('[PlansComponent] No fue posible desmontar un Secure Field de Mercado Pago:', error);
            }
        });
        this.mercadoPagoCardNumberField = null;
        this.mercadoPagoExpirationDateField = null;
        this.mercadoPagoSecurityCodeField = null;
        this.mercadoPagoInstance = null;
    }

    public canModifyConvenio(plan: any): boolean {
        return this.canAddBeneficiaries(plan);
    }
}
